// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:37:28.348Z
// Property: Park at Westpointe (ID: 6767906449165617)
// Collections: 28 amenities, 6 floorplans (live), 39 photos, 65 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165617",
  "property_external_id": "kklnq8b",
  "property_zillow_url": "https://www.zillow.com/homedetails/301-Pointe-Parkway-Blvd-1421-Yukon-OK-73099/312760182_zpid/",
  "property_apartments_url": "https://www.apartments.com/park-at-westpointe-yukon-ok/kklnq8b/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Park+on+Westpointe/data=!4m2!3m1!1s0x0:0xc129f633d222250a?sa=X&ved=2ahUKEwiw8PDt_LySAxWKIkQIHZA2JTYQ_BJ6BAhCEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "park-at-westpointe",
  "property_name": "Park at Westpointe",
  "property_website_url": "https://www.caseusa.com/apartments/ok/yukon/park-at-westpointe/",
  "property_domain": null,
  "property_address": "301 Pointe Parkway Blvd",
  "property_full_address": "301 Pointe Parkway Blvd, Yukon, OK, 73099",
  "property_address_1": "301 Pointe Parkway Blvd",
  "property_address_2": null,
  "property_address_city": "Yukon",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73099",
  "property_address_country": "US",
  "property_address_county": "Canadian County",
  "property_neighborhood_address": "Southwest Oklahoma City",
  "property_address_latitude": "35.4619",
  "property_address_longitude": "-97.7207",
  "property_email": "westpointe@caseusa.com",
  "property_phone": "(405) 783-3140",
  "property_call_tracking_phone": "844-689-0657",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Park at Westpointe in Yukon, Oklahoma, your ideal living space awaits. Choose from stylish one and two-bedroom floor plans, and enjoy resort-like amenities such as a sparkling pool, state-of-the-art fitness center, and serene picnic area. Experience comfort and convenience—your new home is just a click away! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Discover Your Ideal Home at Park at Westpointe**  \n\nWelcome to Park at Westpointe, where comfort meets convenience in beautiful Yukon, Oklahoma. Our community offers a variety of thoughtfully designed floor plans to suit every lifestyle, including one-bedroom and two-bedroom apartments. Each residence boasts modern amenities, including air conditioning, high-speed internet access, and spacious walk-in closets, ensuring you have everything you need for a relaxed and enjoyable living experience.\n\nOur exceptional property amenities set us apart. Dive into relaxation at our sparkling pool, stay active in our fully equipped fitness center, or unwind in our inviting clubhouse. For professionals on the go, our business center and package service make life easier. Enjoy the luxury of on-site maintenance and a dedicated property manager, ensuring your needs are always met. Plus, our gated community provides peace of mind for you and your loved ones.\n\nYour furry friends will love our dog park, while outdoor enthusiasts can take advantage of our picnic area and grilling stations. Each apartment comes equipped with modern kitchens featuring dishwashers, microwaves, and refrigerators, and many include charming details like vaulted ceilings and cozy fireplaces.\n\nExperience the vibrant lifestyle at Park at Westpointe, where you'll find the perfect blend of tranquility and activity. Don’t wait to call this remarkable community your home! **Explore our availability today or schedule a tour to see all that Park at Westpointe has to offer.** Your ideal apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-6854-767d-a2bb-cf50e75ece44.webp",
  "property_featured_image_media": {
    "alt_text": "Building entrance of a multifamily property with stone accents and manicured lawn.",
    "public_id": "019d20af-6854-767d-a2bb-cf50e75ece44",
    "storage_key": "property/6767906449165617/019d20af-6854-767d-a2bb-cf50e75ece44.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "520",
  "property_year_built": "2011",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.34615384615385",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of 2 pets allowed - Breed restrictions apply",
  "property_pet_policy_description": "Maximum of 2 pets allowed - Breed restrictions apply",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://parkatwestpointeapartmentsyukon.securecafe.com/onlineleasing/park-at-westpointe-i/floorplans.aspx",
  "property_resident_portal_url": "https://parkatwestpointeapartmentsyukon.securecafe.com/residentservices/park-at-westpointe-i/userlogin.aspx",
  "property_apply_now_url": "https://parkatwestpointeapartmentsyukon.securecafe.com/onlineleasing/park-at-westpointe-i/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-8ace-77fe-8575-5c105932fac2.webp",
  "property_primary_logo_media": {
    "alt_text": "The Park at Westpointe Apartment Homes logo",
    "public_id": "019cfb44-8ace-77fe-8575-5c105932fac2",
    "storage_key": "property/6767906449165617/019cfb44-8ace-77fe-8575-5c105932fac2.webp",
    "width": 3072,
    "height": 885
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb45-8202-736d-8d78-06df7ff102c0.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb45-8202-736d-8d78-06df7ff102c0",
    "storage_key": "property/6767906449165617/019cfb45-8202-736d-8d78-06df7ff102c0.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb45-9917-7578-858d-77b7987453fe.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Park at Westpointe Apartment Homes logo",
    "public_id": "019cfb45-9917-7578-858d-77b7987453fe",
    "storage_key": "property/6767906449165617/019cfb45-9917-7578-858d-77b7987453fe.webp",
    "width": 640,
    "height": 184
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb45-a064-7590-a36b-ed92b46e2b12.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Park at Westpointe Apartment Homes logo.",
    "public_id": "019cfb45-a064-7590-a36b-ed92b46e2b12",
    "storage_key": "property/6767906449165617/019cfb45-a064-7590-a36b-ed92b46e2b12.webp",
    "width": 640,
    "height": 184
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#000000",
  "property_secondary_color": "#49371b",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#473729",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1110",
  "property_sqft_min": "789",
  "property_sqft_max": "1110",
  "property_price_range": "1049 - 1449",
  "property_price_min": "1049",
  "property_price_max": "1449",
  "property_available_units": 27,
  "property_facebook_url": "https://www.facebook.com/TheParkAtWestpointe/photos/d41d8cd9/1504679821661311/",
  "property_instagram_url": "https://www.instagram.com/theparkatwestpointe/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ3W0gq8IIsocRCiUi0jP2KcE",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Yukon%2C+OK+73099",
  "property_tiktok_url": "https://www.tiktok.com/@theparkonwestpointe",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Park at Westpointe",
  "property_home_romance_title": "Experience Joyful Living in Your Ideal Apartment Community",
  "property_home_amenities_blurb": "Welcome to Park at Westpointe, where modern living meets comfort in Yukon, Oklahoma. Choose from spacious one and two-bedroom floor plans, enhanced by resort-style amenities including a sparkling pool, fitness center, and dog park. Unwind in the clubhouse or enjoy a picnic in our lush outdoor spaces. Your ideal home awaits!",
  "property_home_floorplans_blurb": "At Park at Westpointe in Yukon, Oklahoma, your dream apartment awaits. Our diverse selection of one and two-bedroom floor plans caters to your unique lifestyle. Ready to elevate your living experience? Browse our available homes today and uncover the perfect space that feels just right for you.",
  "property_home_gallery_blurb": "Welcome to Park at Westpointe, where comfort meets convenience in Yukon, Oklahoma. Choose from thoughtfully designed one and two-bedroom floor plans. Enjoy a vibrant lifestyle with amenities like a sparkling pool, a fully equipped fitness center, and a welcoming dog park. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Park at Westpointe, where your ideal living experience meets vibrant Yukon, Oklahoma! Enjoy spacious one and two-bedroom floor plans while being just steps away from community treasures like the tranquil Lake Overholser Iron Bridge, the fun at FUNBOX OKC, and local parks like Chisholm Trail. Your perfect lifestyle awaits!",
  "property_home_reviews_blurb": "At Park at Westpointe in Yukon, Oklahoma, residents revel in the blend of luxury and community. With spacious apartments bathed in sunlight and well-maintained amenities, it's no wonder Chris Tate declares, “I love living here! The office staff is so friendly, and I love the sense of community.” Join us!",
  "property_neighborhood_blurb": "At Park at Westpointe in Yukon, Oklahoma, vibrant living meets a bustling neighborhood. Close to Southwestern Christian University and picturesque parks, like Lake Overholser and Route 66 Park, you’ll relish outdoor adventures and community spirit. Unwind at FUNBOX OKC or engage with local favorites—experience a lifestyle that’s uniquely yours!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Park at Westpointe in Yukon, Oklahoma, modern comfort meets serene living. Enjoy our resort-style pool, a state-of-the-art fitness center, and a vibrant clubhouse. Each apartment boasts spacious floor plans, stylish features like vaulted ceilings, and a pet-friendly dog park. Experience community living tailored for you.",
  "property_applynow_blurb": "At Park at Westpointe in Yukon, Oklahoma, your dream apartment awaits! Choose from spacious one- or two-bedroom floor plans, complete with modern amenities like a refreshing pool, fitness center, and inviting dog park. Join our vibrant community—lease online today and step into a lifestyle you’ll love!",
  "property_contactus_blurb": "At Park at Westpointe in Yukon, Oklahoma, your ideal space awaits! Choose from our thoughtfully designed one and two-bedroom floor plans, tailored for comfort and style. Ready to find your perfect home? Our leasing team is here to help—connect with us today for all your inquiries!",
  "property_faqs_blurb": "At Park at Westpointe in Yukon, Oklahoma, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Got questions? Our FAQs page is brimming with helpful insights to guide you through your journey in finding your ideal home. Browse now and let us help you settle in seamlessly!",
  "property_floorplans_blurb": "At Park at Westpointe in Yukon, Oklahoma, your dream apartment awaits! Choose from our stylish one and two-bedroom floor plans, each thoughtfully designed for your comfort and lifestyle. Ensure your ideal living space is just a click away—browse our available options today and picture yourself at home with us!",
  "property_gallery_blurb": "At Park at Westpointe in Yukon, Oklahoma, envision your ideal lifestyle with spacious one and two-bedroom floor plans. Picture sun-soaked afternoons by the inviting pool or relaxing evenings in our serene dog park. Every detail, from vaulted ceilings to a vibrant clubhouse, is designed for comfort and community.",
  "property_interactivemap_blurb": "At Park at Westpointe in Yukon, Oklahoma, your ideal home awaits with spacious one- and two-bedroom layouts. Enjoy resort-style amenities, including a refreshing pool, state-of-the-art fitness center, and a relaxing dog park. Use our interactive community map to find your perfect apartment and start your new chapter today!",
  "property_pets_blurb": "At Park at Westpointe in Yukon, OK, your furry friends can enjoy life alongside you in our vibrant community. With a pet-friendly policy allowing up to two pets, you’ll find the perfect home for your beloved companions—just be mindful of our breed restrictions. Embrace a lifestyle of comfort and convenience today!",
  "property_referafriend_blurb": "At Park at Westpointe in Yukon, Oklahoma, we believe great friends make great neighbors! Share the joy of our stylish one and two-bedroom apartments with someone special. Refer a friend today and let them experience the vibrant community you love! Their new home awaits right around the corner.",
  "property_residentaccess_blurb": "Welcome to Park at Westpointe in Yukon, Oklahoma, where modern living meets comfort. Choose from spacious one and two-bedroom floor plans tailored to your lifestyle. Seamlessly manage your home with our resident portal—pay rent, schedule maintenance, and stay connected with your community, all at your fingertips!",
  "property_reviews_blurb": "At Park at Westpointe in Yukon, Oklahoma, residents rave about the friendly staff and luxurious living experience. As one resident shares, “It’s like living in a house more than an apartment,” thanks to spacious layouts and abundant sunlight. Experience unmatched comfort and a vibrant community atmosphere right here!",
  "property_created_at": "1753982388526",
  "property_scheduletour_blurb": "At Park at Westpointe in Yukon, Oklahoma, our thoughtfully designed one and two-bedroom apartments offer a blend of comfort and style. Ready to find your perfect fit? Schedule a tour today and hear firsthand what our residents love about calling this vibrant community home!",
  "property_thankyou_blurb": "Thank you for reaching out to Park at Westpointe in Yukon, Oklahoma! With thoughtfully designed one and two-bedroom floor plans, your ideal home awaits. Our dedicated team will be in touch soon, ready to guide you through the exceptional living experience we offer. Enjoy a seamless transition into your new lifestyle!",
  "property_virtualtours_blurb": "Experience modern living at Park at Westpointe in Yukon, Oklahoma! Choose from spacious one and two-bedroom floor plans designed for comfort and style. Immerse yourself in our vibrant community and visualize your new home—take a virtual tour today and see why our apartments for rent are your next perfect destination!",
  "property_copyright": "2025 All Rights Reserved. Park at Westpointe",
  "property_seo_title_home": "Park at Westpointe |  Apartments in Yukon, Oklahoma",
  "property_seo_description_home": "Elevate your lifestyle at Park at Westpointe in Yukon, OK. Enjoy spacious apartments, luxurious amenities, and a welcoming community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Yukon, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Park at Westpointe in Yukon, OK. Choose from stylish one and two-bedroom floor plans designed for comfort and modern living.",
  "property_seo_title_amenities": "Amenities | Yukon, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort and style at Park at Westpointe in Yukon, OK, featuring resort amenities like a pool, fitness center, and dog park!",
  "property_seo_title_gallery": "Gallery | Apartments in Yukon, Oklahoma",
  "property_seo_description_gallery": "Envision life at Park at Westpointe in Yukon, OK. Enjoy resort-style amenities, stunning floor plans, and a welcoming community. Picture yourself here!",
  "property_seo_title_virtualtours": "Virtual Tours | Park at Westpointe Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Park at Westpointe in Yukon, OK. Step inside our one- and two-bedroom apartments with a virtual tour today! Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Park at Westpointe Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Park at Westpointe in Yukon! Use our interactive map to browse floor plans, explore amenities, and see pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Yukon, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood around Park at Westpointe in Yukon, OK. Dive into local favorites, parks, and dining just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Park at Westpointe",
  "property_seo_description_contact": "Transform your living experience at Park at Westpointe in Yukon, OK. Inquire about our one & two-bedroom floor plans today – your ideal home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Yukon, Oklahoma",
  "property_seo_description_faqs": "Find answers to your questions at Park at Westpointe in Yukon, OK. From amenities to floor plans, browse our FAQs for insights into our vibrant community!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Yukon, Oklahoma",
  "property_seo_description_reviews": "Experience life at Park at Westpointe! Check out glowing resident reviews and see why our Yukon community is the perfect place to call home. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Yukon, Oklahoma",
  "property_seo_description_applynow": "Unlock your future at Park at Westpointe! Enjoy spacious one & two-bedroom apartments with premier amenities. Lease now and experience life in Yukon, OK.",
  "property_seo_title_residentaccess": "Resident Access | Park at Westpointe",
  "property_seo_description_residentaccess": "Access your resident portal at Park at Westpointe in Yukon! Effortlessly pay rent, schedule maintenance, and stay connected with your community today!",
  "property_seo_title_referafriend": "Refer A Friend | Park at Westpointe",
  "property_seo_description_referafriend": "Refer a friend to Park at Westpointe in Yukon, OK! Great friends make incredible neighbors. Join our vibrant community and enjoy a life of comfort together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Park at Westpointe",
  "property_seo_description_scheduletour": "Discover comfort and style at Park at Westpointe, Yukon, OK. Schedule a tour today and envision your new home amid stunning landscapes!",
  "property_seo_title_privacy": "Privacy Policy | Park at Westpointe",
  "property_seo_description_privacy": "Your privacy matters at Park at Westpointe! Review our commitment to your data protection and transparency. Stay informed about your rights today!",
  "property_seo_title_accessibility": "Website Accessibility | Park at Westpointe",
  "property_seo_description_accessibility": "At Park at Westpointe in Yukon, OK, we embrace digital inclusion, ensuring accessibility for all. Join our vibrant community where comfort meets connectivity.",
  "property_seo_title_sitemap": "Sitemap | Park at Westpointe",
  "property_seo_description_sitemap": "Navigate your way to your perfect home at Park at Westpointe in Yukon, OK. Check out our sitemap to find your next apartment oasis!",
  "property_seo_title_thankyou": "Thank You | Park at Westpointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Park at Westpointe! Our team will connect soon to help you find your perfect apartment in Yukon, Oklahoma. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Yukon, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865525985",
  "amenities": [
    {
      "id": "custom_a236112d-ae32-458f-a224-b87477803f33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Barbecue and Picnic Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7b087c6-777f-420e-8fc2-8286a9a7a48f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Courtyards with Pet Stations",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7adc4a71-cfcb-418a-9bc4-fae0e12e33f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3e77e321-4d06-4b44-a1da-36ea66ee5c7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Two Resort‑Style Swimming Pools",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c6fa353-4302-4227-a030-56a87742e000",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Grilling Area and Sundecks",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bb40a31f-b299-43d2-aed7-7beac681b3bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8c3000e9-069a-4df3-b39e-a051f8a091aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Limited Access Gates",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21608fee-37f7-4a39-9726-d30c5358c634",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_188c7860-77f1-40f7-a6fb-569589b7b413",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_847894ae-d658-42c9-aa3f-60e40332c80d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Package Receiving",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5cf5f481-3dd7-43e9-a06b-752d6fc1899c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Onsite Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e5f4ec0e-a0e7-4e5e-a006-fc5cc8998e8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af4d3521-1315-48f4-bfa5-a2617002b5a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_254d6d6c-22d5-4e32-a65c-64330deddac6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Cozy Fireplace*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_216c7f1b-3fc3-4311-8057-de5ea20acb64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_861ef409-3fb2-4e55-be7d-2087e41f0856",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Bright, Expansive Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_43318ce4-b996-4c3a-b755-d4c21aa9b720",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8e357a8d-7a23-4f16-aca1-003d517044fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Plush Carpeting",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0713ff2d-27fb-42dc-a4e0-66def626bf06",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Private Balcony/Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aa9a5ad3-2011-42a8-b8eb-9dcd8da45198",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67605bc1-1f1f-4f63-8781-e810882461e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0948f649-ffae-4c8a-a584-8276239bf081",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Side‑by‑Side Refrigerator w/ Ice‑Maker & Filtered Water",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a76c4a89-89f1-4e35-be83-9ad21d9ff025",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e11b966e-83ff-4633-9034-8b42c41aab5c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Handicap Accessible*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9135af61-8f64-4879-884b-65351652f777",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f4c5db9e-200c-41c9-a9d8-4b8a547589dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Central Heat & Air Conditioning",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6ad4eb9b-4d3d-4ed7-8102-48b465c8eb67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2d2a02f3-ba7a-414e-8930-1f3755f7110b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_7c5d19b9-e607-4018-acf4-d2ec3c9ec3f7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-5ba3-723b-a41d-73664ee523d5.webp",
      "image_media": {
        "alt_text": "Outdoor community grilling area with stone fireplace and table, surrounded by apartment buildings.",
        "public_id": "019d20af-5ba3-723b-a41d-73664ee523d5",
        "storage_key": "property/6767906449165617/019d20af-5ba3-723b-a41d-73664ee523d5.webp",
        "width": 1600,
        "height": 1067
      },
      "title": "Community",
      "description": "Spacious outdoor gathering area at the property featuring a stone fireplace, built-in grill, and communal seating for residents.",
      "link": "",
      "alt_text": "Outdoor community grilling area with stone fireplace and table, surrounded by apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165617/019cfb44-8b23-747d-9eae-17d93e91099b.webp"
    },
    {
      "id": "custom_2ee563c3-f41c-49fc-80a4-ac38adc601a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-5b9e-740c-b312-35b79c1b2b19.webp",
      "image_media": {
        "alt_text": "Open-concept community lounge with a stone fireplace, high wood-beam ceiling, and comfortable seating.",
        "public_id": "019d20af-5b9e-740c-b312-35b79c1b2b19",
        "storage_key": "property/6767906449165617/019d20af-5b9e-740c-b312-35b79c1b2b19.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Spacious resident lounge featuring a stone fireplace, modern furnishings, and a bright, welcoming gathering area.",
      "link": "",
      "alt_text": "Open-concept community lounge with a stone fireplace, high wood-beam ceiling, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-198b-74d6-956f-85b4da4351cf.webp"
    },
    {
      "id": "custom_4408e83a-ce9c-42fe-98af-8fdba18875b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-5bdb-7281-a258-b0e53a0cd459.webp",
      "image_media": {
        "alt_text": "Outdoor pool area at an apartment community with lounge chairs and surrounding buildings.",
        "public_id": "019d20af-5bdb-7281-a258-b0e53a0cd459",
        "storage_key": "property/6767906449165617/019d20af-5bdb-7281-a258-b0e53a0cd459.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Outdoor pool area at an apartment community with lounge seating and nearby residential buildings.",
      "link": "",
      "alt_text": "Outdoor pool area at an apartment community with lounge chairs and surrounding buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-1be0-701a-be6a-f7619e17a5cf.webp"
    },
    {
      "id": "custom_73eee1d0-d213-4f5e-aa8e-41bad34f3d72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-5b98-77ba-8a2d-a82750dc910c.webp",
      "image_media": {
        "alt_text": "Outdoor pool area with seating and a shaded pergola at a multifamily community.",
        "public_id": "019d20af-5b98-77ba-8a2d-a82750dc910c",
        "storage_key": "property/6767906449165617/019d20af-5b98-77ba-8a2d-a82750dc910c.webp",
        "width": 998,
        "height": 598
      },
      "title": "Community",
      "description": "Outdoor pool area with seating and a shaded pergola, surrounded by apartment buildings and landscaped grounds.",
      "link": "",
      "alt_text": "Outdoor pool area with seating and a shaded pergola at a multifamily community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165617/019cfb44-93ab-74a8-917a-6f15e1187fc4.webp"
    },
    {
      "id": "custom_7692d79c-588a-48ee-a3db-5ae92ea87051",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-6854-767d-a2bb-cf50e75ece44.webp",
      "image_media": {
        "alt_text": "Exterior apartment building entrance with stone columns, ramp and landscaped lawn.",
        "public_id": "019d20af-6854-767d-a2bb-cf50e75ece44",
        "storage_key": "property/6767906449165617/019d20af-6854-767d-a2bb-cf50e75ece44.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A welcoming exterior entry to a multifamily community featuring a stone facade, ramp access, and well-kept landscaping.",
      "link": "",
      "alt_text": "Exterior apartment building entrance with stone columns, ramp and landscaped lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-1beb-7338-906b-f431af3c24e0.webp"
    },
    {
      "id": "custom_30fea5b0-9b52-4b40-8c34-f97590ecf603",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-6936-7283-aa11-d0695ca79333.webp",
      "image_media": {
        "alt_text": "Entrance sign for The Park on West Pointe with brick pillars, landscaping, and red flag banners.",
        "public_id": "019d20af-6936-7283-aa11-d0695ca79333",
        "storage_key": "property/6767906449165617/019d20af-6936-7283-aa11-d0695ca79333.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior entrance sign for The Park on West Pointe, featuring brick pillars, landscaping, and flags.",
      "link": "",
      "alt_text": "Entrance sign for The Park on West Pointe with brick pillars, landscaping, and red flag banners.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-1c44-74af-8b39-bad892372eac.webp"
    },
    {
      "id": "custom_5efa4fb9-6a87-4229-9a11-ebe07bb0879e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-6b08-7145-85cc-0ec82e3a9e2a.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-building apartment complex with balconies and a large grassy lawn.",
        "public_id": "019d20af-6b08-7145-85cc-0ec82e3a9e2a",
        "storage_key": "property/6767906449165617/019d20af-6b08-7145-85cc-0ec82e3a9e2a.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "A comfortable apartment community featuring green open space, outdoor seating, and multi-building living.",
      "link": "",
      "alt_text": "Exterior view of a multi-building apartment complex with balconies and a large grassy lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-283d-778a-8dde-4836edac490e.webp"
    },
    {
      "id": "custom_c094b9b3-43d4-4190-a3f4-fb4d90fcd9c3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-7364-76fa-ae31-a9d39ff28765.webp",
      "image_media": {
        "alt_text": "View from a balcony overlooking a communal pool area and apartment buildings.",
        "public_id": "019d20af-7364-76fa-ae31-a9d39ff28765",
        "storage_key": "property/6767906449165617/019d20af-7364-76fa-ae31-a9d39ff28765.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Sunny view of a courtyard-style community featuring a pool, lounge seating, and modern multifamily buildings.",
      "link": "",
      "alt_text": "View from a balcony overlooking a communal pool area and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-2bc0-7309-a33e-2920c312f662.webp"
    },
    {
      "id": "custom_6081c520-7c90-46a4-bc75-9d4120f03d54",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-7443-71c7-b525-43f21b067365.webp",
      "image_media": {
        "alt_text": "Grassy community courtyard with a playground and surrounding apartment buildings.",
        "public_id": "019d20af-7443-71c7-b525-43f21b067365",
        "storage_key": "property/6767906449165617/019d20af-7443-71c7-b525-43f21b067365.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Communal outdoor space featuring a playground within a multi-building apartment complex.",
      "link": "",
      "alt_text": "Grassy community courtyard with a playground and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-2bb8-71fc-90dd-669f5e18f55d.webp"
    },
    {
      "id": "custom_c1d18127-8265-47e6-9721-a6ee5b2263c7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-77ef-737a-8428-8f9e3040cbf4.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-building apartment community with a green lawn, trees, and a sidewalk.",
        "public_id": "019d20af-77ef-737a-8428-8f9e3040cbf4",
        "storage_key": "property/6767906449165617/019d20af-77ef-737a-8428-8f9e3040cbf4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with brick and siding buildings, a central lawn, trees, and a concrete walkway.",
      "link": "",
      "alt_text": "Exterior view of a multi-building apartment community with a green lawn, trees, and a sidewalk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-3cde-776b-bd2e-2e98b86b3d1f.webp"
    },
    {
      "id": "custom_6088e2b3-c7b8-474e-8680-8f4ff4bae6fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-792c-702c-9841-40dc57f550d5.webp",
      "image_media": {
        "alt_text": "Bright on-site gym with treadmills, elliptical, weight machine, and dumbbell rack.",
        "public_id": "019d20af-792c-702c-9841-40dc57f550d5",
        "storage_key": "property/6767906449165617/019d20af-792c-702c-9841-40dc57f550d5.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Modern on-site fitness center with cardio and strength equipment.",
      "link": "",
      "alt_text": "Bright on-site gym with treadmills, elliptical, weight machine, and dumbbell rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-5e9b-7232-bee8-2148aea121de.webp"
    },
    {
      "id": "custom_2dfd6c69-e243-44eb-ab43-ab5b1ff4e2c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-81dd-7369-a6c1-86ee187733a0.webp",
      "image_media": {
        "alt_text": "Apartment laundry closet with detergent shelf, wall art, and a FETCH tub filled with tennis balls.",
        "public_id": "019d20af-81dd-7369-a6c1-86ee187733a0",
        "storage_key": "property/6767906449165617/019d20af-81dd-7369-a6c1-86ee187733a0.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "A compact apartment laundry closet featuring a detergent shelf, decorative wall art, and a FETCH tub filled with tennis balls.",
      "link": "",
      "alt_text": "Apartment laundry closet with detergent shelf, wall art, and a FETCH tub filled with tennis balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-1b66-7094-bde0-c06f8e4e59cc.webp"
    },
    {
      "id": "custom_8edbd6a6-ab2b-4194-92db-ccb13777de7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-82bf-72dd-b372-0b58340f5727.webp",
      "image_media": {
        "alt_text": "L-shaped kitchen corner with dark wood cabinets, stainless steel stove and microwave, and granite-like countertops.",
        "public_id": "019d20af-82bf-72dd-b372-0b58340f5727",
        "storage_key": "property/6767906449165617/019d20af-82bf-72dd-b372-0b58340f5727.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with granite counters, rich wood cabinets, and stainless-steel appliances.",
      "link": "",
      "alt_text": "L-shaped kitchen corner with dark wood cabinets, stainless steel stove and microwave, and granite-like countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-196b-74d3-a676-412a8fb3aca6.webp"
    },
    {
      "id": "custom_928db70c-1822-4bc4-a3f0-1ecbceda6391",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-83fc-71ac-9847-3a12cfe6911c.webp",
      "image_media": {
        "alt_text": "Kitchen featuring dark wood cabinets, stainless steel appliances, and an island with two stools.",
        "public_id": "019d20af-83fc-71ac-9847-3a12cfe6911c",
        "storage_key": "property/6767906449165617/019d20af-83fc-71ac-9847-3a12cfe6911c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with patterned countertops, island seating, and full-size stainless steel appliances.",
      "link": "",
      "alt_text": "Kitchen featuring dark wood cabinets, stainless steel appliances, and an island with two stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-2049-7022-96f7-c9e54668ae0e.webp"
    },
    {
      "id": "custom_a916900c-4d6c-4751-914e-39a674840065",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-8b26-7428-bf89-b61885654cd0.webp",
      "image_media": {
        "alt_text": "Dining area in an apartment with a white table, four chairs, wall art, and a door with blinds.",
        "public_id": "019d20af-8b26-7428-bf89-b61885654cd0",
        "storage_key": "property/6767906449165617/019d20af-8b26-7428-bf89-b61885654cd0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Photo of a contemporary apartment dining area featuring a white table, four chairs, wall art, and a glass door.",
      "link": "",
      "alt_text": "Dining area in an apartment with a white table, four chairs, wall art, and a door with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-1970-7284-b591-4d753a247f82.webp"
    },
    {
      "id": "custom_99c7d3ef-9dd9-46f8-9fb6-095630a63e21",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-8cdc-74ba-8823-fc114bd134cc.webp",
      "image_media": {
        "alt_text": "Bright living room with beige carpet, white sofa, coffee table, and open kitchen.",
        "public_id": "019d20af-8cdc-74ba-8823-fc114bd134cc",
        "storage_key": "property/6767906449165617/019d20af-8cdc-74ba-8823-fc114bd134cc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious, light-filled living area with an open-concept kitchen, ideal for entertaining in a modern apartment.",
      "link": "",
      "alt_text": "Bright living room with beige carpet, white sofa, coffee table, and open kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-1c44-74af-8b39-b7db385baa9d.webp"
    },
    {
      "id": "custom_b496aaeb-eb19-45c8-8c53-61c5b7c0d39b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-8d1f-701f-bd33-4b19a8e16cd5.webp",
      "image_media": {
        "alt_text": "Laundry/utility closet with electrical panel, washer hookups, a wire shelf, and cleaning supplies.",
        "public_id": "019d20af-8d1f-701f-bd33-4b19a8e16cd5",
        "storage_key": "property/6767906449165617/019d20af-8d1f-701f-bd33-4b19a8e16cd5.webp",
        "width": 1280,
        "height": 1920
      },
      "title": "Apartment",
      "description": "Compact apartment laundry area featuring an electrical panel, washer hookups, a wire shelf, and cleaning items.",
      "link": "",
      "alt_text": "Laundry/utility closet with electrical panel, washer hookups, a wire shelf, and cleaning supplies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-1bb8-748d-a677-843e85643e0c.webp"
    },
    {
      "id": "custom_314b60c9-048f-4b0f-ac09-17040edf370b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-9048-70e5-a6fb-9182135b3e9b.webp",
      "image_media": {
        "alt_text": "U-shaped kitchen with dark wood cabinets and stainless steel stove, microwave, and dishwasher.",
        "public_id": "019d20af-9048-70e5-a6fb-9182135b3e9b",
        "storage_key": "property/6767906449165617/019d20af-9048-70e5-a6fb-9182135b3e9b.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Well-equipped apartment kitchen with granite-style counters and ample cabinet space.",
      "link": "",
      "alt_text": "U-shaped kitchen with dark wood cabinets and stainless steel stove, microwave, and dishwasher.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-283e-70d6-984b-d47b65dec7d2.webp"
    },
    {
      "id": "custom_f3a06756-3e32-4364-bccc-c9b8ca7314e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-9659-7441-bdf7-bdb0dbc03bfe.webp",
      "image_media": {
        "alt_text": "Cozy apartment living room with a leather sofa, armchair, coffee table, TV stand, and a fireplace.",
        "public_id": "019d20af-9659-7441-bdf7-bdb0dbc03bfe",
        "storage_key": "property/6767906449165617/019d20af-9659-7441-bdf7-bdb0dbc03bfe.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment living room featuring a gas fireplace, neutral decor, and ample natural light from large windows.",
      "link": "",
      "alt_text": "Cozy apartment living room with a leather sofa, armchair, coffee table, TV stand, and a fireplace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-28f4-77bd-877b-f17e783ece85.webp"
    },
    {
      "id": "custom_78ab597e-7153-405f-9dd8-1eecab6526d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-999d-7100-8629-fbb3b9cdc1b4.webp",
      "image_media": {
        "alt_text": "Bright living room with a white sectional sofa, large windows, and a dining area.",
        "public_id": "019d20af-999d-7100-8629-fbb3b9cdc1b4",
        "storage_key": "property/6767906449165617/019d20af-999d-7100-8629-fbb3b9cdc1b4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living area in a sunlit apartment with a white sectional, modern decor, and open dining space.",
      "link": "",
      "alt_text": "Bright living room with a white sectional sofa, large windows, and a dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-3794-7778-ae9a-78ef0671b77d.webp"
    },
    {
      "id": "custom_7ea16551-70cd-4c47-8980-be3f63f31536",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-9b15-74ab-849f-7a8d7e7d321c.webp",
      "image_media": {
        "alt_text": "Furnished bedroom in an apartment with a queen bed, dresser, and windows with curtains.",
        "public_id": "019d20af-9b15-74ab-849f-7a8d7e7d321c",
        "storage_key": "property/6767906449165617/019d20af-9b15-74ab-849f-7a8d7e7d321c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, modern bedroom in a stylish apartment unit with a queen bed and neutral decor.",
      "link": "",
      "alt_text": "Furnished bedroom in an apartment with a queen bed, dresser, and windows with curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-2adb-7002-8244-cb2e7a7c3543.webp"
    },
    {
      "id": "custom_5413fa16-fff5-4da3-b99d-d36ef1b70a76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-a1b4-709a-81cc-a51944c99822.webp",
      "image_media": {
        "alt_text": "Dining area with a round marble table, four gray chairs, and large sunny windows.",
        "public_id": "019d20af-a1b4-709a-81cc-a51944c99822",
        "storage_key": "property/6767906449165617/019d20af-a1b4-709a-81cc-a51944c99822.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright dining space in a contemporary apartment, featuring a round marble table, gray seating, and abundant natural light.",
      "link": "",
      "alt_text": "Dining area with a round marble table, four gray chairs, and large sunny windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-2d8e-751f-8e3d-576c007ddc90.webp"
    },
    {
      "id": "custom_361594bc-2bc3-4acf-9ffe-aa34d4d634d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-a227-76a9-bb51-439a563ee831.webp",
      "image_media": {
        "alt_text": "Bedroom in a neutral apartment with a bed, dresser, and large windows.",
        "public_id": "019d20af-a227-76a9-bb51-439a563ee831",
        "storage_key": "property/6767906449165617/019d20af-a227-76a9-bb51-439a563ee831.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy, modern apartment bedroom with neutral decor, a ceiling fan, and natural light from two windows.",
      "link": "",
      "alt_text": "Bedroom in a neutral apartment with a bed, dresser, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-32db-757b-a1f4-6d7fc5d5fe3a.webp"
    },
    {
      "id": "custom_ec2396a7-b668-409f-a69c-a95e91afcaf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-a40b-718c-b747-72820c0cd185.webp",
      "image_media": {
        "alt_text": "Open-concept living room with a sofa, patterned chair, coffee table, and a kitchen bar.",
        "public_id": "019d20af-a40b-718c-b747-72820c0cd185",
        "storage_key": "property/6767906449165617/019d20af-a40b-718c-b747-72820c0cd185.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Open-concept apartment living area with neutral decor, a sofa, coffee table, and a kitchen bar.",
      "link": "",
      "alt_text": "Open-concept living room with a sofa, patterned chair, coffee table, and a kitchen bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-3864-74b5-9650-772490c198a1.webp"
    },
    {
      "id": "custom_d94e6d2d-6628-46d7-86b4-9733b91898b3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-a715-7502-8da6-b39c1c016c4c.webp",
      "image_media": {
        "alt_text": "Indoor dining area in a neutral-toned apartment with a small dark table, two chairs, and abstract wall art.",
        "public_id": "019d20af-a715-7502-8da6-b39c1c016c4c",
        "storage_key": "property/6767906449165617/019d20af-a715-7502-8da6-b39c1c016c4c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A neutral dining nook in an apartment with a dark wood table, two chairs, abstract artwork, and a door to the outdoors.",
      "link": "",
      "alt_text": "Indoor dining area in a neutral-toned apartment with a small dark table, two chairs, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-3b01-7399-b5f8-6571b564515f.webp"
    },
    {
      "id": "custom_48356201-9cfe-4b1b-a421-d5924c60a71c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-ab84-7578-b603-2dfd6af111cd.webp",
      "image_media": {
        "alt_text": "U-shaped kitchen with dark wood cabinets, stainless steel stove and microwave, granite countertops.",
        "public_id": "019d20af-ab84-7578-b603-2dfd6af111cd",
        "storage_key": "property/6767906449165617/019d20af-ab84-7578-b603-2dfd6af111cd.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with granite countertops, stainless appliances, and ample cabinet storage.",
      "link": "",
      "alt_text": "U-shaped kitchen with dark wood cabinets, stainless steel stove and microwave, granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-3f5b-757d-a9eb-eb2adfcc94a0.webp"
    },
    {
      "id": "custom_b088971b-b87a-472f-9885-5294143a95e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-ad2b-76cb-a65c-be37501de860.webp",
      "image_media": {
        "alt_text": "Open-concept living room with beige carpet, white sofa, and a kitchen with dark wood cabinets and a breakfast bar.",
        "public_id": "019d20af-ad2b-76cb-a65c-be37501de860",
        "storage_key": "property/6767906449165617/019d20af-ad2b-76cb-a65c-be37501de860.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Open-concept living area with dining space, a sofa, and a kitchen with dark wood cabinets and a breakfast bar.",
      "link": "",
      "alt_text": "Open-concept living room with beige carpet, white sofa, and a kitchen with dark wood cabinets and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-4288-712f-afb6-57240cf8528e.webp"
    },
    {
      "id": "custom_51977652-ce84-49c0-ba48-0ce1ee224db5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-aff7-72ad-878c-1873ca62be2d.webp",
      "image_media": {
        "alt_text": "Living/dining area in an apartment with a round table, gray chairs, and large windows.",
        "public_id": "019d20af-aff7-72ad-878c-1873ca62be2d",
        "storage_key": "property/6767906449165617/019d20af-aff7-72ad-878c-1873ca62be2d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious living and dining area in a modern apartment with large windows and neutral decor.",
      "link": "",
      "alt_text": "Living/dining area in an apartment with a round table, gray chairs, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-42c5-709d-80f7-fff1df098e27.webp"
    },
    {
      "id": "custom_6ebeeb1f-446e-4dff-9dc6-9523ed912ee6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-b0fb-729f-9d2a-9dd35d446566.webp",
      "image_media": {
        "alt_text": "Living room with TV on a white console, beige carpet, and an open kitchen with bar seating.",
        "public_id": "019d20af-b0fb-729f-9d2a-9dd35d446566",
        "storage_key": "property/6767906449165617/019d20af-b0fb-729f-9d2a-9dd35d446566.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright open-concept living space in a modern apartment with a seating area and a bar-height kitchen.",
      "link": "",
      "alt_text": "Living room with TV on a white console, beige carpet, and an open kitchen with bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-46a7-729e-8c8e-71d4b79463bc.webp"
    },
    {
      "id": "custom_c0e3a04c-a3ff-4014-95e6-9ad4edd28191",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-b680-7582-8db4-00a272c7aaac.webp",
      "image_media": {
        "alt_text": "Bathroom with a granite vanity, dark wood cabinetry, toilet, and a shower/tub combo.",
        "public_id": "019d20af-b680-7582-8db4-00a272c7aaac",
        "storage_key": "property/6767906449165617/019d20af-b680-7582-8db4-00a272c7aaac.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Apartment bathroom featuring granite countertop, wood cabinets, a toilet, and a shower-tub combo.",
      "link": "",
      "alt_text": "Bathroom with a granite vanity, dark wood cabinetry, toilet, and a shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-4900-76fb-aa7c-3509e1b43d24.webp"
    },
    {
      "id": "custom_3e9bff0f-56a7-419e-aed5-fec2307609cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-bb72-73ce-93f8-3bdf0fbbeb65.webp",
      "image_media": {
        "alt_text": "Kitchen in an apartment with dark wood cabinets, granite countertops, and a stainless steel refrigerator.",
        "public_id": "019d20af-bb72-73ce-93f8-3bdf0fbbeb65",
        "storage_key": "property/6767906449165617/019d20af-bb72-73ce-93f8-3bdf0fbbeb65.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen with abundant cabinetry and stainless-steel appliances, ideal for cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen in an apartment with dark wood cabinets, granite countertops, and a stainless steel refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-4a0c-713a-846d-f38a42192f53.webp"
    },
    {
      "id": "custom_a6b6a2d9-cd0c-4f6c-86ba-77e5d1066964",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-bcc0-765b-bb0e-643c7e69005f.webp",
      "image_media": {
        "alt_text": "Living room with a stone fireplace, sofa, and TV stand.",
        "public_id": "019d20af-bcc0-765b-bb0e-643c7e69005f",
        "storage_key": "property/6767906449165617/019d20af-bcc0-765b-bb0e-643c7e69005f.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy living area in a spacious apartment featuring a stone fireplace, comfortable seating, and a TV console.",
      "link": "",
      "alt_text": "Living room with a stone fireplace, sofa, and TV stand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-49f7-721c-a19c-1296c07b7e7e.webp"
    },
    {
      "id": "custom_683fea4d-0c51-4b94-9a54-c7968e2b0cae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-c40b-76ef-8fdf-d290fc6ae036.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen bed, upholstered headboard, two matching nightstands, dresser, and ceiling fan.",
        "public_id": "019d20af-c40b-76ef-8fdf-d290fc6ae036",
        "storage_key": "property/6767906449165617/019d20af-c40b-76ef-8fdf-d290fc6ae036.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, modern apartment bedroom with neutral decor and coordinated furnishings.",
      "link": "",
      "alt_text": "Bedroom with a queen bed, upholstered headboard, two matching nightstands, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-4a26-70ba-862f-50641bc68147.webp"
    },
    {
      "id": "custom_61aac35d-4395-4cde-ac91-6e54fde1d50c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-c3fd-719b-a313-32ffa7c36f61.webp",
      "image_media": {
        "alt_text": "Spacious living area with glass dining table, wooden chairs, and wall art near windows with curtains.",
        "public_id": "019d20af-c3fd-719b-a313-32ffa7c36f61",
        "storage_key": "property/6767906449165617/019d20af-c3fd-719b-a313-32ffa7c36f61.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment living area with a glass dining table, stylish chairs and wall art.",
      "link": "",
      "alt_text": "Spacious living area with glass dining table, wooden chairs, and wall art near windows with curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-4c1e-70bf-a166-74643724eaa4.webp"
    },
    {
      "id": "custom_90e99ae6-fae6-41d7-9ffe-eada93d24d05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-cb21-767e-94fc-156e41c1af80.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a dark wood bed, matching nightstands, and a ceiling fan.",
        "public_id": "019d20af-cb21-767e-94fc-156e41c1af80",
        "storage_key": "property/6767906449165617/019d20af-cb21-767e-94fc-156e41c1af80.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment bedroom featuring coordinated dark wood furniture and abstract artwork.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a dark wood bed, matching nightstands, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-598b-77f5-bdd9-0824d71929eb.webp"
    },
    {
      "id": "custom_fce3722b-2265-45a4-bdb1-c9d9f28a8c16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-cda8-7207-bf61-36d2e2762409.webp",
      "image_media": {
        "alt_text": "Bathroom with dark wood vanity, granite-style countertop, toilet, and a white tub/shower.",
        "public_id": "019d20af-cda8-7207-bf61-36d2e2762409",
        "storage_key": "property/6767906449165617/019d20af-cda8-7207-bf61-36d2e2762409.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a dark wood vanity, granite-style countertop, toilet, and tub/shower combo.",
      "link": "",
      "alt_text": "Bathroom with dark wood vanity, granite-style countertop, toilet, and a white tub/shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-4e3d-73c5-86dc-b73c795a4005.webp"
    },
    {
      "id": "custom_254c2e28-cd71-4075-8b38-d1ff665341f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-d194-7241-8d5e-91f4e5cb76db.webp",
      "image_media": {
        "alt_text": "Bathroom with dark wood vanity, mirror, toilet, and tub/shower with a white curtain.",
        "public_id": "019d20af-d194-7241-8d5e-91f4e5cb76db",
        "storage_key": "property/6767906449165617/019d20af-d194-7241-8d5e-91f4e5cb76db.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bathroom in a modern apartment with a dark wood vanity, granite countertop, and a tub/shower.",
      "link": "",
      "alt_text": "Bathroom with dark wood vanity, mirror, toilet, and tub/shower with a white curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-54e7-7333-8fcd-00da91f71bae.webp"
    },
    {
      "id": "custom_ccd8b82a-b6e4-4b77-b739-c5c97ae2943d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-d6f5-74cc-889b-1fa5ecd83411.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with a dark wood vanity, mirror, toilet, and a tub/shower with a gray curtain.",
        "public_id": "019d20af-d6f5-74cc-889b-1fa5ecd83411",
        "storage_key": "property/6767906449165617/019d20af-d6f5-74cc-889b-1fa5ecd83411.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment bathroom with granite counter, dark wood cabinets, and a tub/shower combo.",
      "link": "",
      "alt_text": "Bathroom in an apartment with a dark wood vanity, mirror, toilet, and a tub/shower with a gray curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-59ca-73b6-a25b-5c980ed384c7.webp"
    },
    {
      "id": "custom_8a09b587-3a86-437f-9710-0fe4f2400c76",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d20af-d83b-7589-83d2-7af37bb90fcf.webp",
      "image_media": {
        "alt_text": "Bright bedroom with a queen bed, round mirror, two nightstands, and a window with blinds.",
        "public_id": "019d20af-d83b-7589-83d2-7af37bb90fcf",
        "storage_key": "property/6767906449165617/019d20af-d83b-7589-83d2-7af37bb90fcf.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright bedroom in a modern apartment with a queen bed, round mirror, neutral tones, and ample storage.",
      "link": "",
      "alt_text": "Bright bedroom with a queen bed, round mirror, two nightstands, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-5e8a-736d-889e-08bd24db0e3f.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_409e033a-2961-46a7-a22f-5961b289d1b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "6200 SW 3rd St, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Relaxed chain steakhouse serving cuts of beef, ribs and other down-to-earth fare.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and rolls. They also highlight the fast service, friendly staff, and reasonable prices.\n\nSome reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-4555-7008-8cf4-743c46b02d4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4555-7008-8cf4-743c46b02d4c",
        "storage_key": "property/6767906449165617/019d2709-4555-7008-8cf4-743c46b02d4c.webp",
        "width": 1076,
        "height": 724
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-west-sw-3rd-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=12279087547535667782&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.4609531",
      "poi_longitude": "-97.6232978",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-789-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7844-73da-af4b-2b1e163da02a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7844-73da-af4b-2b1e163da02a",
        "storage_key": "property/6767906449165617/019d2709-7844-73da-af4b-2b1e163da02a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdwTj7s0PsocRRjLJLBEVaKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_f06cff72-a705-4c30-80c9-5f0642784eba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "520 S MacArthur Blvd, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Family chain featuring an all-you-can-eat buffet of meat and seafood staples, plus a salad bar and a dessert selection.",
      "poi_long_description": "Diners say this buffet restaurant offers a wide variety of fresh and delicious food, including steak, chicken, ham, baked beans, mac and cheese, green beans, fried chicken, Salisbury steak, rolls, and honey butter cornbread. They also highlight the attentive and friendly service, with many reviewers praising specific servers for their exceptional service.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-45db-71fb-8d8f-ddeb014aafdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-45db-71fb-8d8f-ddeb014aafdc",
        "storage_key": "property/6767906449165617/019d2709-45db-71fb-8d8f-ddeb014aafdc.webp",
        "width": 960,
        "height": 639
      },
      "poi_business_url": "https://www.goldencorral.com/locations/913/golden-corral-s-macarthur-blvd?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=913",
      "poi_directions_map_url": "https://maps.google.com/?cid=4595961913688049149&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "35.4609499",
      "poi_longitude": "-97.6168342",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-949-9991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7844-73da-af4b-2b1e163da02a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7844-73da-af4b-2b1e163da02a",
        "storage_key": "property/6767906449165617/019d2709-7844-73da-af4b-2b1e163da02a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdxWs29MPsocR_cWZkgIjyD8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_21f6538e-3ff0-4308-8640-26081b4d38e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6330 SW 3rd St, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Family-friendly chain restaurant known for unlimited soup, salad, and breadsticks.",
      "poi_long_description": "People say this Italian restaurant serves delicious pasta, soup, salad, and breadsticks. They also highlight the fast and friendly service, and the attentive staff.\n\nOther reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-4560-74ab-a012-e0d90c5830c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4560-74ab-a012-e0d90c5830c0",
        "storage_key": "property/6767906449165617/019d2709-4560-74ab-a012-e0d90c5830c0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/oklahoma-city/westgate-marketplace/4444?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:oklahoma-city-ok-4444_pl:locurl_rd:1785",
      "poi_directions_map_url": "https://maps.google.com/?cid=12446364743026005606&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "35.46141679999999",
      "poi_longitude": "-97.6257249",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-440-0345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7844-73da-af4b-2b1e163da02a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7844-73da-af4b-2b1e163da02a",
        "storage_key": "property/6767906449165617/019d2709-7844-73da-af4b-2b1e163da02a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5bwMnc4PsocRZtYCRcpeuqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_204dd69f-d7c9-4db0-b1d9-dc8537a975d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "6420 SW 3rd St, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Casual, Christian-based fast-food chain known for chicken sandwiches and waffle fries, as well as waffle fries.",
      "poi_long_description": "Diners say this chicken restaurant serves up delicious chicken strips and fries, and they appreciate the friendly staff and incredible customer service. They also highlight the fresh, made-to-order food and the efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-4592-731a-9722-2042ac68a4de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4592-731a-9722-2042ac68a4de",
        "storage_key": "property/6767906449165617/019d2709-4592-731a-9722-2042ac68a4de.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/i-40-macarthur?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=2544618934186639130&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.4610829",
      "poi_longitude": "-97.627301",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-440-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7844-73da-af4b-2b1e163da02a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7844-73da-af4b-2b1e163da02a",
        "storage_key": "property/6767906449165617/019d2709-7844-73da-af4b-2b1e163da02a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl92j8LYPsocRGn_tTHBNUCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_02a6192a-20bf-4e88-9582-780f88205adb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Hook & Reel Cajun Seafood & Bar",
      "poi_type": "Restaurants",
      "poi_address": "6320 SW 3rd St, Oklahoma City, OK 73128, USA",
      "poi_short_description": "Seafood boil spot offering shrimp, crab and other shellfish, plus beer and cocktails.",
      "poi_long_description": "Diners say this seafood restaurant serves up delicious crab legs, shrimp boil, and a variety of other seafood boils, with many praising the customizable options and attentive service. They also highlight the quick service, fresh food, and lively atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-49ef-77bb-be98-3898ea321bbc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-49ef-77bb-be98-3898ea321bbc",
        "storage_key": "property/6767906449165617/019d2709-49ef-77bb-be98-3898ea321bbc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://hookreel.com/location/oklahomacity/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16297817718322086635&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hook--reel-cajun-seafood--bar",
      "poi_latitude": "35.4608913",
      "poi_longitude": "-97.6250147",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-506-0800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7844-73da-af4b-2b1e163da02a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7844-73da-af4b-2b1e163da02a",
        "storage_key": "property/6767906449165617/019d2709-7844-73da-af4b-2b1e163da02a.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhwRxAbcPsocR68Kngt16LeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_4318046f-bc5c-428a-9690-677fe04e9165",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "OKC Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "7624 W Reno Ave Suite 380, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Relaxed outdoor mall featuring more than 70 brand-name designer stores of shoes, clothing and more.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores and good deals. They also highlight the friendly staff and nice shopping experience.\n\nOther reviews mention the food court can have limited options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-4a29-763d-a10e-076da8772dc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4a29-763d-a10e-076da8772dc0",
        "storage_key": "property/6767906449165617/019d2709-4a29-763d-a10e-076da8772dc0.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.okcoutlets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1773095145334850603&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "okc-outlets",
      "poi_latitude": "35.4625898",
      "poi_longitude": "-97.6473972",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-787-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-78b2-74ba-b1c7-bd8e4007f521.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78b2-74ba-b1c7-bd8e4007f521",
        "storage_key": "property/6767906449165617/019d2709-78b2-74ba-b1c7-bd8e4007f521.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJdWyLw68PsocRK0Sn8qNMmxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e429363c-b629-4571-904e-a60d414d4e93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "6800 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Home improvement chain stocking a range of tools, appliances, lighting, paint, and flooring.",
      "poi_long_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-49e3-7478-8033-5a9a9242efaf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-49e3-7478-8033-5a9a9242efaf",
        "storage_key": "property/6767906449165617/019d2709-49e3-7478-8033-5a9a9242efaf.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/W-Oklahoma-City/OK/Oklahoma-City/73127/3908?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=4879427188602399743&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.4634233",
      "poi_longitude": "-97.6319266",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-789-3895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-78b2-74ba-b1c7-bd8e4007f521.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78b2-74ba-b1c7-bd8e4007f521",
        "storage_key": "property/6767906449165617/019d2709-78b2-74ba-b1c7-bd8e4007f521.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBRp1xskPsocR_2sH_Cw1t0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_0a2aee97-86b5-4cce-80b8-0c7347989dd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "715 N Czech Hall Rd, Yukon, OK 73099, USA",
      "poi_short_description": "Large, clean grocery store offering a deli, butcher shop, meat counter and bakery that operates 24/7.",
      "poi_long_description": "People say this grocery store offers a wide variety of fresh produce, meats, deli items, premade items, sushi, and bakery goods. They highlight the reasonable prices, clean and well-organized store, and wide aisles. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-4afc-70f4-b972-3b48fa549d03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4afc-70f4-b972-3b48fa549d03",
        "storage_key": "property/6767906449165617/019d2709-4afc-70f4-b972-3b48fa549d03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4133772343963612855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.4736012",
      "poi_longitude": "-97.7462437",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-805-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7890-76fe-b87c-e23ff44c7ba4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7890-76fe-b87c-e23ff44c7ba4",
        "storage_key": "property/6767906449165617/019d2709-7890-76fe-b87c-e23ff44c7ba4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq_53UKUJsocRt_ZIkAscXjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cee4ceaa-367b-4443-8d97-5476a8fbac40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1605 Garth Brooks Blvd, Yukon, OK 73099, USA",
      "poi_short_description": "Big-box home improvement supplies, including flooring, appliances, plumbing and plants.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products and new items. They also highlight the friendly and helpful staff, and the clean and well-stocked store.\n\nOther reviews mention the customer service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-4f05-724f-a264-e9fd96d3d8f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4f05-724f-a264-e9fd96d3d8f5",
        "storage_key": "property/6767906449165617/019d2709-4f05-724f-a264-e9fd96d3d8f5.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Yukon/1134?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1134-_-na-_-0-_-0&y_source=1_MTE4MzI1Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9868427532835134405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.4818407",
      "poi_longitude": "-97.7575803",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-354-8806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-78b2-74ba-b1c7-bd8e4007f521.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78b2-74ba-b1c7-bd8e4007f521",
        "storage_key": "property/6767906449165617/019d2709-78b2-74ba-b1c7-bd8e4007f521.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJeZ7ciXEIsocRxZtSUo6y84g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_d1e12c3d-0fe2-41bb-8d05-bce8e19f9f0c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Nike Factory Store - Oklahoma City",
      "poi_type": "Shopping & Retail",
      "poi_address": "7654 W Reno Ave Suite 760, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "Shoppers say this sportswear store offers great deals on a wide variety of athletic shoes and apparel, with many mentioning Nike as a popular brand. They also highlight the helpful and efficient staff, who provide excellent customer service even during busy periods.\n\nSome reviews mention the selection can be limited after major events or holidays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-4ea6-74da-96ec-fada80c9462b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4ea6-74da-96ec-fada80c9462b",
        "storage_key": "property/6767906449165617/019d2709-4ea6-74da-96ec-fada80c9462b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.nike.com/retail/s/nike-factory-store-oklahoma-city?cp=84620811901_seo_%3Fcp%3D84620811901_seo_&y_source=1_NTQzNzQ1Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4703973447302258998&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "nike-factory-store---oklahoma-city",
      "poi_latitude": "35.4618552",
      "poi_longitude": "-97.648372",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-495-5935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-78b2-74ba-b1c7-bd8e4007f521.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78b2-74ba-b1c7-bd8e4007f521",
        "storage_key": "property/6767906449165617/019d2709-78b2-74ba-b1c7-bd8e4007f521.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJB_2OabIPsocRNiFSd-3eR0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_3201bef8-3216-4307-9d1f-f2e1c3b31442",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Bethany Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "6700 NW 35th St, Bethany, OK 73008, USA",
      "poi_short_description": "Public library offering kid-friendly activities, meeting rooms, and other resources.",
      "poi_long_description": "People say this public library offers a diverse selection of books and a variety of activities for all ages. They highlight the cozy atmosphere and the availability of meeting rooms. They also like the helpful and attentive staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-4fa3-723a-a4da-8792a6731449.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-4fa3-723a-a4da-8792a6731449",
        "storage_key": "property/6767906449165617/019d2709-4fa3-723a-a4da-8792a6731449.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15531442417609680617&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-library---metropolitan-library-system",
      "poi_latitude": "35.5062789",
      "poi_longitude": "-97.6316452",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-789-8363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-78b3-719b-9979-a3ae2b111550.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78b3-719b-9979-a3ae2b111550",
        "storage_key": "property/6767906449165617/019d2709-78b3-719b-9979-a3ae2b111550.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV4NBRVwFsocR6SYP95bEitc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_6835687b-1363-4e4d-8f63-9794fbf2d103",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Southwestern Christian University",
      "poi_type": "Education",
      "poi_address": "7210 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-506e-737a-908e-2fb3a8af0fc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-506e-737a-908e-2fb3a8af0fc4",
        "storage_key": "property/6767906449165617/019d2709-506e-737a-908e-2fb3a8af0fc4.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.swcu.edu",
      "poi_directions_map_url": "https://maps.google.com/?cid=6939619905505591377&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southwestern-christian-university",
      "poi_latitude": "35.5120221",
      "poi_longitude": "-97.6398185",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-789-7661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-78b3-719b-9979-a3ae2b111550.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78b3-719b-9979-a3ae2b111550",
        "storage_key": "property/6767906449165617/019d2709-78b3-719b-9979-a3ae2b111550.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAzjOyG4FsocRUQDkT4l7TmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_246c4eb1-8248-4808-8cdc-19e0e1f0a17c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "SNU Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Bethany, OK 73008, USA",
      "poi_short_description": "Stadium offering a field and a restroom.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-53d5-705f-b860-768411bb4cfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-53d5-705f-b860-768411bb4cfe",
        "storage_key": "property/6767906449165617/019d2709-53d5-705f-b860-768411bb4cfe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://snuathletics.com/facilities/snu-football-stadium/1",
      "poi_directions_map_url": "https://maps.google.com/?cid=14871021148287990153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "snu-football-stadium",
      "poi_latitude": "35.5210386",
      "poi_longitude": "-97.661832",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7c20-73df-a7c8-d365fbc2e796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c20-73df-a7c8-d365fbc2e796",
        "storage_key": "property/6767906449165617/019d2709-7c20-73df-a7c8-d365fbc2e796.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFyihiaEFsocRifkGv_F6YM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_72629dc4-f554-406a-8064-300b85d27055",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Lake Overholser Iron Bridge",
      "poi_type": "Entertainment",
      "poi_address": "8703-8709 Overholser Dr, Bethany, OK 73008, USA",
      "poi_short_description": "Historic bridge on the former Route 66, still open to traffic, with scenic views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-54a6-761b-b9ed-675b2f4f1ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-54a6-761b-b9ed-675b2f4f1ee5",
        "storage_key": "property/6767906449165617/019d2709-54a6-761b-b9ed-675b2f4f1ee5.webp",
        "width": 720,
        "height": 491
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1592759798430792050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lake-overholser-iron-bridge",
      "poi_latitude": "35.5146149",
      "poi_longitude": "-97.6638523",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlQwMnJkFsocRcnn9DZmeGhY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_c8af888b-5f78-4f9b-a577-b35de4633148",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Bronco Stadium",
      "poi_type": "Entertainment",
      "poi_address": "430 W Forster Dr, Mustang, OK 73064, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-55a0-727d-827e-f6cdabcd9467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-55a0-727d-827e-f6cdabcd9467",
        "storage_key": "property/6767906449165617/019d2709-55a0-727d-827e-f6cdabcd9467.webp",
        "width": 1170,
        "height": 647
      },
      "poi_business_url": "https://mustangbroncos.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17118796830537682038&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bronco-stadium",
      "poi_latitude": "35.3832109",
      "poi_longitude": "-97.7302603",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7c20-73df-a7c8-d365fbc2e796.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c20-73df-a7c8-d365fbc2e796",
        "storage_key": "property/6767906449165617/019d2709-7c20-73df-a7c8-d365fbc2e796.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEyGBUbsLsocRdgxIogQvku0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_43b25aef-9ce7-4823-bcd1-92b28ae2ec4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "FUNBOX OKC",
      "poi_type": "Entertainment",
      "poi_address": "7624 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Amusement park with an obstacle course, ninja wall, and other attractions, plus a playground.",
      "poi_long_description": "People say this amusement park offers a variety of bounce houses and is fun for kids and families. They highlight the clean environment and the reasonable cost. They also like the friendly and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-558f-7509-8302-eed59e0bbc50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-558f-7509-8302-eed59e0bbc50",
        "storage_key": "property/6767906449165617/019d2709-558f-7509-8302-eed59e0bbc50.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://funbox.com/okc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13601958894721549338&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "funbox-okc",
      "poi_latitude": "35.4633477",
      "poi_longitude": "-97.6463812",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-455-4597",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvSZggr4dsocRGsRXaYzdw7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_99c976e0-eef7-4a88-8694-0297c8512c83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Freedom Trail Park Splash Pad",
      "poi_type": "Entertainment",
      "poi_address": "Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-5977-7478-9898-095c0e244d55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5977-7478-9898-095c0e244d55",
        "storage_key": "property/6767906449165617/019d2709-5977-7478-9898-095c0e244d55.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.yukonok.gov/483/Freedom-Trail-Splash-Pad",
      "poi_directions_map_url": "https://maps.google.com/?cid=9436248172752489266&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "freedom-trail-park-splash-pad",
      "poi_latitude": "35.4850487",
      "poi_longitude": "-97.7508791",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-350-8937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXwAFUQAJsocRMktXvbdJ9II",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_cf55ed4e-3712-43d2-94a9-89aa3c1113c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Crunch Fitness - Yukon",
      "poi_type": "Health and Wellness",
      "poi_address": "11241 W Reno Ave, Yukon, OK 73099, USA",
      "poi_short_description": "Gym providing month-to-month memberships, group fitness classes, cardio equipment, and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-5c1d-7168-af50-8399661a78e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5c1d-7168-af50-8399661a78e6",
        "storage_key": "property/6767906449165617/019d2709-5c1d-7168-af50-8399661a78e6.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.crunch.com/locations/yukon",
      "poi_directions_map_url": "https://maps.google.com/?cid=6604966592399683600&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---yukon",
      "poi_latitude": "35.4650598",
      "poi_longitude": "-97.7227318",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-265-9145",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSZj-PcJsocREDBOBR-OqVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9b6a7a75-0bc6-4248-a3df-1b7c69bd4210",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Neel Veterinary Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2700 N MacArthur Blvd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-5ae8-7529-97e7-da5a41a1494b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5ae8-7529-97e7-da5a41a1494b",
        "storage_key": "property/6767906449165617/019d2709-5ae8-7529-97e7-da5a41a1494b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://neel.vet/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4132737864806100553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neel-veterinary-hospital",
      "poi_latitude": "35.4972708",
      "poi_longitude": "-97.6183664",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-947-8387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYV66BPkPsocRSe6SHTFvWjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_46c2d8f4-9d8a-4fe8-afba-d8f47053031d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1101 Garth Brooks Blvd, Yukon, OK 73099, USA",
      "poi_short_description": "Chain fitness center offering a variety of equipment, massage beds, and tanning services.",
      "poi_long_description": "People say this gym offers a wide variety of cardio and resistance training equipment, and the facilities are clean and well-maintained. They also highlight the friendly and helpful staff, and the positive and welcoming vibe.\n\nSome reviews mention the equipment can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-5aa6-72fa-8aa6-eb6af16a5606.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5aa6-72fa-8aa6-eb6af16a5606",
        "storage_key": "property/6767906449165617/019d2709-5aa6-72fa-8aa6-eb6af16a5606.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/yukon-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=711117955316607878&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.4928286",
      "poi_longitude": "-97.758255",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-350-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZfxNtwHsocRhmsMQANm3gk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_336b2080-b97e-4f36-bfc0-92a95a3f944c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Bethany YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "3400 N Mueller Ave, Bethany, OK 73008, USA",
      "poi_short_description": "Chain fitness center offering amenities such as a pool, basketball courts, and water aerobics classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-5e13-7649-8cf4-a35bbc7beb23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5e13-7649-8cf4-a35bbc7beb23",
        "storage_key": "property/6767906449165617/019d2709-5e13-7649-8cf4-a35bbc7beb23.webp",
        "width": 994,
        "height": 533
      },
      "poi_business_url": "https://ymcaokc.org/branches/bethany/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8306823524238509196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-ymca",
      "poi_latitude": "35.5051032",
      "poi_longitude": "-97.6316419",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-789-0231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9wBj710FsocRjEQY3vvDR3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_43d2eedb-80ac-4505-8922-7c38fb132c8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Bounce Academy Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "1901 W Vandament Ave, Yukon, OK 73099, USA",
      "poi_short_description": "Clean gymnastics center specializing in children’s classes and parties.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-5f49-726b-b5fe-711b5d985f14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5f49-726b-b5fe-711b5d985f14",
        "storage_key": "property/6767906449165617/019d2709-5f49-726b-b5fe-711b5d985f14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bagymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9145115498533390941&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bounce-academy-gymnastics",
      "poi_latitude": "35.4942138",
      "poi_longitude": "-97.7726666",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-494-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-78b3-719b-9979-a3ae2b111550.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-78b3-719b-9979-a3ae2b111550",
        "storage_key": "property/6767906449165617/019d2709-78b3-719b-9979-a3ae2b111550.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN9_lNtwHsocRXYoA0Bf66X4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ce533435-c8d9-4b5c-b8eb-d93c9eef1e9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "12444 NW 10th St STE 601, Yukon, OK 73099, USA",
      "poi_short_description": "Chain outpost for cosmetics and hair-care products from more than 500 brands.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-5fdf-7135-ac61-774391779156.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-5fdf-7135-ac61-774391779156",
        "storage_key": "property/6767906449165617/019d2709-5fdf-7135-ac61-774391779156.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/yukon-ok-1264",
      "poi_directions_map_url": "https://maps.google.com/?cid=9771740599807671119&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.4765787",
      "poi_longitude": "-97.7482269",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-324-2234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKVubhGQIsocRT3vMeE0ynIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_34894ac4-a646-4b2f-8895-48681bb5ba9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Four Star Fitness - Yukon",
      "poi_type": "Health and Wellness",
      "poi_address": "1091 Cornwell Dr, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment and free weights, including multiple sets of dumbbells and a posing room. They highlight the clean and spacious facility, and the 24-hour accessibility. They also like the friendly and helpful staff, and the excellent customer service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-60e3-757a-8f6f-66534161dcf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-60e3-757a-8f6f-66534161dcf6",
        "storage_key": "property/6767906449165617/019d2709-60e3-757a-8f6f-66534161dcf6.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://fourstarfitnessokc.com/the-best-gym-in-yukon-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9012206437616025016&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "four-star-fitness---yukon",
      "poi_latitude": "35.4955347",
      "poi_longitude": "-97.7408077",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-467-4789",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHUwL6coHsocRuH2XnAHKEX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_7453dad2-03f4-44e4-b00a-2b12604aa9dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Gold's Gym Yukon",
      "poi_type": "Health and Wellness",
      "poi_address": "12701 NW 10th St, Yukon, OK 73099, USA",
      "poi_short_description": "Longstanding, clean gym featuring cardio equipment, weight areas and a pool.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-643d-7203-92e8-66cffa1952b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-643d-7203-92e8-66cffa1952b9",
        "storage_key": "property/6767906449165617/019d2709-643d-7203-92e8-66cffa1952b9.webp",
        "width": 1024,
        "height": 597
      },
      "poi_business_url": "https://www.goldsgym.com/yukon/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8221592306829412751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym-yukon",
      "poi_latitude": "35.4794755",
      "poi_longitude": "-97.7532002",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-494-1281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIylJt28IsocRj8mmqKT2GHI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_addabcc3-9cb3-4c98-b43f-6a049449067d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Yukon Hills Animal Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "380 W Vandament Ave, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-643f-7549-b0fe-2f248de4bea6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-643f-7549-b0fe-2f248de4bea6",
        "storage_key": "property/6767906449165617/019d2709-643f-7549-b0fe-2f248de4bea6.webp",
        "width": 1253,
        "height": 704
      },
      "poi_business_url": "https://yukonhillsah.com/?utm_source=gmb&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4940993075067768751&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yukon-hills-animal-hospital",
      "poi_latitude": "35.4930122",
      "poi_longitude": "-97.7487399",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-354-1949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrxwjR9YHsocRr08U9QXvkUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_65ae481e-310b-41b8-bb7a-ef4ce87c415d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Bethany Children's Health Center",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 NW 39th Expy, Bethany, OK 73008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-6469-73ae-bb18-694ea3d75d73.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6469-73ae-bb18-694ea3d75d73",
        "storage_key": "property/6767906449165617/019d2709-6469-73ae-bb18-694ea3d75d73.webp",
        "width": 800,
        "height": 599
      },
      "poi_business_url": "https://www.bethanychildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7263694039261901520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bethany-childrens-health-center",
      "poi_latitude": "35.5107205",
      "poi_longitude": "-97.6341932",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-789-6711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7c9e-754b-b864-72fbd7576376.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c9e-754b-b864-72fbd7576376",
        "storage_key": "property/6767906449165617/019d2709-7c9e-754b-b864-72fbd7576376.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLWDqGmgFsocR0PJTdz7TzWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_dc9b0e81-03aa-4d78-b76e-5ea41e3f7e80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "INTEGRIS Health Emergency Department Canadian Valley Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1201 Health Center Pkwy, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-65ff-747a-b8f6-1645fef12388.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-65ff-747a-b8f6-1645fef12388",
        "storage_key": "property/6767906449165617/019d2709-65ff-747a-b8f6-1645fef12388.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://integrishealth.org/locations/emergency-room/integris-health-emergency-department-canadian-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=5498566190179253766&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integris-health-emergency-department-canadian-valley-hospital",
      "poi_latitude": "35.4850381",
      "poi_longitude": "-97.7634018",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-717-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7c9e-754b-b864-72fbd7576376.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c9e-754b-b864-72fbd7576376",
        "storage_key": "property/6767906449165617/019d2709-7c9e-754b-b864-72fbd7576376.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8X7G1MqvdIgRBn6bO9HUTkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_72f91544-665a-4c5f-a0ee-8f21431ce70b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Chisholm Trail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 W Vandament Ave, Yukon, OK 73099, USA",
      "poi_short_description": "Sprawling park for leisure and outdoor activities, featuring playgrounds and a pond.",
      "poi_long_description": "Visitors say this city park offers beautiful walking trails, a large playground, and a pond where you can feed ducks and geese. They also highlight the impressive Christmas light displays and drone shows during the holiday season.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-6915-707a-8a03-89c8ea6d81d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6915-707a-8a03-89c8ea6d81d3",
        "storage_key": "property/6767906449165617/019d2709-6915-707a-8a03-89c8ea6d81d3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yukonok.gov/457/Chisholm-Trail-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1454155337706392218&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chisholm-trail-park",
      "poi_latitude": "35.4899474",
      "poi_longitude": "-97.7484834",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-350-8937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7c8f-770d-9e8f-035ff0104b18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c8f-770d-9e8f-035ff0104b18",
        "storage_key": "property/6767906449165617/019d2709-7c8f-770d-9e8f-035ff0104b18.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJoTTs53gIsocRmko6QJMyLhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_71fef6ce-b067-411c-a55e-e1edcc53dc03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Wild Horse Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1201 N Mustang Rd, Mustang, OK 73064, USA",
      "poi_short_description": "Large park, with playgrounds, disc golf and a pool.",
      "poi_long_description": "People say this park offers a disc golf course, walking trails, a fishing pond, a dog park, and softball fields. They highlight the well-maintained facilities, ample parking, and family-friendly amenities, including playgrounds, a splash pad, and a pool. They also like the seasonal farmer's market and the annual fireworks display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-6930-773d-8519-a5cfdd64acab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6930-773d-8519-a5cfdd64acab",
        "storage_key": "property/6767906449165617/019d2709-6930-773d-8519-a5cfdd64acab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmustang.org/o/parks/page/wild-horse-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11313752639482791785&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wild-horse-park",
      "poi_latitude": "35.4022213",
      "poi_longitude": "-97.7289461",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-376-3411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7c8f-770d-9e8f-035ff0104b18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c8f-770d-9e8f-035ff0104b18",
        "storage_key": "property/6767906449165617/019d2709-7c8f-770d-9e8f-035ff0104b18.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQGet9kLsocRaYcCMRWGAp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a4b95ea6-8135-430f-902d-853514d3b179",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Overholser Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9398-9000 S Overholser Rd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Peaceful park, lake and dam venue for walking, skating and biking.",
      "poi_long_description": "People say this park offers bike riding, fishing, kayaking, and walking trails. They highlight the relaxing and calm vibe, and the scenic views of the dam and lake. They also like the historic structure and the opportunity to walk across the dam.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-6a2a-77fa-ab6a-a5f827f3045e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6a2a-77fa-ab6a-a5f827f3045e",
        "storage_key": "property/6767906449165617/019d2709-6a2a-77fa-ab6a-a5f827f3045e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/224/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13345590610054369473&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "overholser-park",
      "poi_latitude": "35.4843833",
      "poi_longitude": "-97.6681182",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7c8f-770d-9e8f-035ff0104b18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c8f-770d-9e8f-035ff0104b18",
        "storage_key": "property/6767906449165617/019d2709-7c8f-770d-9e8f-035ff0104b18.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6SWxWJkFsocRwVAUrvMPNbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3bb1ceeb-fa1b-41bb-b296-8d07cdd7ddfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Route 66 Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9901 NW 23rd St, Yukon, OK 73099, USA",
      "poi_short_description": "148 acres of ponds, trails & an observation tower with lake views, plus a Mother Road memorial.",
      "poi_long_description": "People say this park offers a great walking path, access to fishing, and a playground. They highlight the relaxing vibe, family-friendly atmosphere, and clean environment. They also like the long walkways and the scenic lake with ducks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-6b45-778e-abb2-a96959396cf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6b45-778e-abb2-a96959396cf7",
        "storage_key": "property/6767906449165617/019d2709-6b45-778e-abb2-a96959396cf7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/32/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=90707035350423985&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "route-66-park",
      "poi_latitude": "35.4969132",
      "poi_longitude": "-97.6934847",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-297-3882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7c8f-770d-9e8f-035ff0104b18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c8f-770d-9e8f-035ff0104b18",
        "storage_key": "property/6767906449165617/019d2709-7c8f-770d-9e8f-035ff0104b18.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8YR1wPgFsocRsdmwbJFBQgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_71bb3ba2-8699-4c06-874e-17379a1a0b12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Yukon Christmas in the Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2200 S Holly Ave, Yukon, OK 73099, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-6e1c-776d-8a39-fa6b874a472a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6e1c-776d-8a39-fa6b874a472a",
        "storage_key": "property/6767906449165617/019d2709-6e1c-776d-8a39-fa6b874a472a.webp",
        "width": 1280,
        "height": 692
      },
      "poi_business_url": "https://www.yukonchristmas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3320141239171860691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yukon-christmas-in-the-park",
      "poi_latitude": "35.4829574",
      "poi_longitude": "-97.7492989",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-350-8937",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7c8f-770d-9e8f-035ff0104b18.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7c8f-770d-9e8f-035ff0104b18",
        "storage_key": "property/6767906449165617/019d2709-7c8f-770d-9e8f-035ff0104b18.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJaxniKQAJsocR08j2vN2CEy4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3268a565-7930-4081-8e0d-9c2fd5415f10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Hobby Lobby Transportation Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7210-A SW 29th St, Oklahoma City, OK 73179, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-6e06-76ed-80fe-e449c2c46550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6e06-76ed-80fe-e449c2c46550",
        "storage_key": "property/6767906449165617/019d2709-6e06-76ed-80fe-e449c2c46550.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://careers.hobbylobby.com/current-openings/distribution",
      "poi_directions_map_url": "https://maps.google.com/?cid=13971354854011465596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hobby-lobby-transportation-offices",
      "poi_latitude": "35.4342047",
      "poi_longitude": "-97.6392657",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-745-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD2RzAswPsocRfG9IYDc55ME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_492b0b0e-8e42-4a72-b0ca-f138df636f22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "7725 Connect",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7725 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-6efb-731f-a878-aab599a77bbe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6efb-731f-a878-aab599a77bbe",
        "storage_key": "property/6767906449165617/019d2709-6efb-731f-a878-aab599a77bbe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://7725connect.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7415117686874367476&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "7725-connect",
      "poi_latitude": "35.4651921",
      "poi_longitude": "-97.6493758",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-232-3242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT4bmHaYPsocR9OXczT_K52Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_358cf880-f073-4c7a-bc61-0804a794c0ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Schlumberger TLM-D&M",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10546 NW 10th St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-6fac-71f2-9732-7128583d172f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-6fac-71f2-9732-7128583d172f",
        "storage_key": "property/6767906449165617/019d2709-6fac-71f2-9732-7128583d172f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16503236905686134745&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "schlumberger-tlm-dm",
      "poi_latitude": "35.4771982",
      "poi_longitude": "-97.7056063",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-709-1731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0NXwLYIsocR2e-JH4dGB-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_95753acf-2435-40dc-9658-a3d790560988",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "CACI",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7725 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7332-769b-a08a-0412f598c105.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-7332-769b-a08a-0412f598c105",
        "storage_key": "property/6767906449165617/019d2709-7332-769b-a08a-0412f598c105.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=822969494413870097&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "caci",
      "poi_latitude": "35.4653077",
      "poi_longitude": "-97.6494573",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw22o8XEPsocREYSFF2XGaws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f6c0c3ea-bdfa-4049-8fd5-3a1fe5518637",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Pacebutler Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5915 NW 23rd St, Oklahoma City, OK 73127, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-732c-7795-a127-a64f2f39df7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-732c-7795-a127-a64f2f39df7f",
        "storage_key": "property/6767906449165617/019d2709-732c-7795-a127-a64f2f39df7f.webp",
        "width": 500,
        "height": 333
      },
      "poi_business_url": "http://www.pacebutler.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8557959088291269970&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pacebutler-corporation",
      "poi_latitude": "35.4936498",
      "poi_longitude": "-97.6204189",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-755-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-7ca0-71ae-9a62-75795bc3738e",
        "storage_key": "property/6767906449165617/019d2709-7ca0-71ae-9a62-75795bc3738e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEZOm26MesocRUk3t43L6w3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7132fa1e-36eb-489c-988e-f7f1cbcfbbaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Mustang Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "10821 SW 15th St, Yukon, OK 73099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-c352-720e-a32e-e3153ce09794.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c352-720e-a32e-e3153ce09794",
        "storage_key": "property/6767906449165617/019d7912-c352-720e-a32e-e3153ce09794.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://creek.mustangps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6044122451022178986&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mustang-creek-elementary-school",
      "poi_latitude": "35.450715",
      "poi_longitude": "-97.712698",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-324-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8b-76c0-b236-6698fbc62cf7",
        "storage_key": "property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJwVTwnScJsocRquojmFgJ4VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_964e1bfd-f83d-4f1d-8625-8f5e7fcb44e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Mustang Canyon Ridge Intermediate",
      "poi_type": "Education",
      "poi_address": "3600 S Sara Rd, Mustang, OK 73064, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-c1b2-76c4-8a7c-6465b5f6294c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c1b2-76c4-8a7c-6465b5f6294c",
        "storage_key": "property/6767906449165617/019d7912-c1b2-76c4-8a7c-6465b5f6294c.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "https://cri.mustangps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4568505360526115435&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mustang-canyon-ridge-intermediate",
      "poi_latitude": "35.4290187",
      "poi_longitude": "-97.7062383",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-256-6955",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8b-76c0-b236-6698fbc62cf7",
        "storage_key": "property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJe11G1jcJsocRa4KgoGuXZj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_c1f8b9c9-6d19-49e0-8a16-930cded8e378",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Mustang North Middle School",
      "poi_type": "Education",
      "poi_address": "10901 SW 15th St, Yukon, OK 73099, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-c260-70de-af6b-607bf1dce596.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c260-70de-af6b-607bf1dce596",
        "storage_key": "property/6767906449165617/019d7912-c260-70de-af6b-607bf1dce596.webp",
        "width": 606,
        "height": 1280
      },
      "poi_business_url": "https://nms.mustangps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4074915901366691352&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mustang-north-middle-school",
      "poi_latitude": "35.4506304",
      "poi_longitude": "-97.7147636",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-324-2236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8b-76c0-b236-6698fbc62cf7",
        "storage_key": "property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKzCJRCcJsocRGGaNJmwCjTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_691147a9-634a-436e-80e6-1523cba526fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Mustang High School",
      "poi_type": "Education",
      "poi_address": "801 S Snyder Dr, Mustang, OK 73064, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-c5e5-734c-9b33-1f574749ca4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-c5e5-734c-9b33-1f574749ca4a",
        "storage_key": "property/6767906449165617/019d7912-c5e5-734c-9b33-1f574749ca4a.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://mhs.mustangps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3825575183126456984&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mustang-high-school",
      "poi_latitude": "35.3848958",
      "poi_longitude": "-97.7275298",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-376-2404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8b-76c0-b236-6698fbc62cf7",
        "storage_key": "property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8w_UW8cLsocRmGrNO1wsFzU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_85a33294-21f1-4ccc-9e29-c1b1e92d33ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Oklahoma State University Oklahoma City",
      "poi_type": "Education",
      "poi_address": "900 N Portland Ave, Oklahoma City, OK 73107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-cdbc-76ea-a5e3-b21c86f9980c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cdbc-76ea-a5e3-b21c86f9980c",
        "storage_key": "property/6767906449165617/019d7912-cdbc-76ea-a5e3-b21c86f9980c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.osuokc.edu/home/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5945726857955521834&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-state-university-oklahoma-city",
      "poi_latitude": "35.4705492",
      "poi_longitude": "-97.5821887",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-947-4421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8b-76c0-b236-6698fbc62cf7",
        "storage_key": "property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGzr99UMQsocRKjXwUxN3g1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_848bcee4-2846-4842-b50b-3a0ab758590a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Mid-America Christian University",
      "poi_type": "Education",
      "poi_address": "3500 SW 119th St, Oklahoma City, OK 73170, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-ccfd-74bb-9dc5-6d11688b367c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ccfd-74bb-9dc5-6d11688b367c",
        "storage_key": "property/6767906449165617/019d7912-ccfd-74bb-9dc5-6d11688b367c.webp",
        "width": 1280,
        "height": 453
      },
      "poi_business_url": "https://www.macu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1537180270262459685&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mid-america-christian-university",
      "poi_latitude": "35.3477803",
      "poi_longitude": "-97.5784864",
      "poi_miles_from_property": "15.9 mi",
      "poi_walking_minutes": "5 hours 46 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-691-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8b-76c0-b236-6698fbc62cf7",
        "storage_key": "property/6767906449165617/019cfb44-ca8b-76c0-b236-6698fbc62cf7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIw1jLcMSsocRJZ27vE8pVRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_01d03236-261a-4b61-9028-2ba9fe1cd02e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "PREP’D.",
      "poi_type": "Restaurants",
      "poi_address": "11301 W Reno Ave C, Yukon, OK 73099, USA",
      "poi_short_description": "Unassuming grab-&-go eatery offering healthy prepared meals such as poultry & seafood.",
      "poi_long_description": "People say this meal takeaway offers tasty and healthy meals with perfect seasoning. They highlight the convenient meal prepping, variety of options, and affordable prices, especially with bulk deals. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-cdfc-7383-bb63-6015ccb47628.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-cdfc-7383-bb63-6015ccb47628",
        "storage_key": "property/6767906449165617/019d7912-cdfc-7383-bb63-6015ccb47628.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://prepd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1446907399043941678&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "prep-d",
      "poi_latitude": "35.4646539",
      "poi_longitude": "-97.7222812",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-265-0391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8f-70fc-a9ed-950e444aac09",
        "storage_key": "property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy9SkCukIsocRLgXmBp1yFBQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_takeaway"
    },
    {
      "id": "custom_69a22419-97bb-41df-839b-aa0e613d8301",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Cocina El Girasol",
      "poi_type": "Restaurants",
      "poi_address": "342 S Mustang Rd, Yukon, OK 73099, USA",
      "poi_short_description": "Pupusas, fajitas, and other traditional Latin fare served in a relaxed space.",
      "poi_long_description": "People say this restaurant serves delicious, authentic Mexican food, including quesabirrias, enchiladas, and breakfast burritos. They highlight the fresh, homemade taste, generous portions, and reasonable prices. They also like the clean, cozy atmosphere and the friendly, attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-d810-7478-af39-5dce80110356.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-d810-7478-af39-5dce80110356",
        "storage_key": "property/6767906449165617/019d7912-d810-7478-af39-5dce80110356.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cocinaelgirasol342.kwickmenu.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5771986366174623104&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cocina-el-girasol",
      "poi_latitude": "35.4627364",
      "poi_longitude": "-97.7239395",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-467-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8f-70fc-a9ed-950e444aac09",
        "storage_key": "property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbeQHK28JsocRgHU8zAQ3GlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a095dd80-3048-4887-9e6d-be4c586246e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Michael's Grill",
      "poi_type": "Restaurants",
      "poi_address": "2824 W Country Club Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Traditional restaurant offering lobster tails, caesar salads & steaks, along with wine & cocktails.",
      "poi_long_description": "Traditional restaurant offering lobster tails, caesar salads & steaks, along with wine & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-dd00-7298-9efd-de250a351c0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-dd00-7298-9efd-de250a351c0f",
        "storage_key": "property/6767906449165617/019d7912-dd00-7298-9efd-de250a351c0f.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://michaelsgrillokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14432248066412458593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "michael-s-grill",
      "poi_latitude": "35.5469191",
      "poi_longitude": "-97.564716",
      "poi_miles_from_property": "14.3 mi",
      "poi_walking_minutes": "5 hours 12 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-810-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8f-70fc-a9ed-950e444aac09",
        "storage_key": "property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_7RqM6sbsocRYTLVrCalScg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_9c233d54-6038-4961-b8ec-f2ebcd9f319b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Rococo on Western",
      "poi_type": "Restaurants",
      "poi_address": "4308 N Western Ave, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Upscale American cuisine & cocktails presented in a chic space with a fireplace & leather couches.",
      "poi_long_description": "People say this seafood restaurant serves delicious crab cakes, lobster rolls, and oysters. They also highlight the friendly staff, attentive service, and comfortable atmosphere.\n\nOther reviews mention the food can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-ddb6-7249-9b0b-256e4bb88cc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-ddb6-7249-9b0b-256e4bb88cc8",
        "storage_key": "property/6767906449165617/019d7912-ddb6-7249-9b0b-256e4bb88cc8.webp",
        "width": 900,
        "height": 1200
      },
      "poi_business_url": "http://www.loverococo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16998911691634460798&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rococo-on-western",
      "poi_latitude": "35.5149639",
      "poi_longitude": "-97.5293395",
      "poi_miles_from_property": "14.0 mi",
      "poi_walking_minutes": "5 hours 8 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-400-7495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8f-70fc-a9ed-950e444aac09",
        "storage_key": "property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJvTEJpX8csocRfkgblB5E6Os",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_a3ae6f27-d91a-4781-9dce-0e785317896b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Junior's",
      "poi_type": "Restaurants",
      "poi_address": "2601 NW Expressway # Gr1w, Oklahoma City, OK 73112, USA",
      "poi_short_description": "American mainstay offering a surf ’n’ turf menu, cocktails & live piano music amid old-school decor.",
      "poi_long_description": "Diners say this restaurant serves awesome classic food and has a great vibe. They also highlight the excellent and helpful service.\n\nSome reviews mention the restaurant can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-edda-730c-b018-d3f5fad80afa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-edda-730c-b018-d3f5fad80afa",
        "storage_key": "property/6767906449165617/019d7912-edda-730c-b018-d3f5fad80afa.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.juniorsokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6378506848979423401&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "junior-s",
      "poi_latitude": "35.5258333",
      "poi_longitude": "-97.5597222",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 50 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 405-848-5597",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8f-70fc-a9ed-950e444aac09",
        "storage_key": "property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0GtjWcasocRqZDQMi8ChVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_54b69e65-fef5-4b6f-a98d-1683a7057bd9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "The Blue Dolphin",
      "poi_type": "Restaurants",
      "poi_address": "845 S Mustang Rd, Yukon, OK 73099, USA",
      "poi_short_description": "Laid-back restaurant in Southwest Oklahoma City's West Watch neighborhood featuring healthy offerings, coffee, and açaí bowls.",
      "poi_long_description": "People say this restaurant serves delicious acai bowls, sandwiches, and tomato soup. They highlight the fresh ingredients and flavorful smoothie bowls. They also like the friendly service and the management's passion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-f293-7475-85f8-c54736fcbb64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f293-7475-85f8-c54736fcbb64",
        "storage_key": "property/6767906449165617/019d7912-f293-7475-85f8-c54736fcbb64.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thebluedolphin.netlify.app/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=261357766798499378&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-blue-dolphin",
      "poi_latitude": "35.4578245",
      "poi_longitude": "-97.725482",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-652-5576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca8f-70fc-a9ed-950e444aac09",
        "storage_key": "property/6767906449165617/019cfb44-ca8f-70fc-a9ed-950e444aac09.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJweTsXfAJsocRMl5QEYGHoAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c69e11c8-cd78-4825-aac5-38c9b972aaf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Westgate Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "6400 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Strip mall featuring a number of popular stores, as well as restaurants.",
      "poi_long_description": "People say this shopping center offers a wide selection of stores, restaurants, and retailers. They also highlight the convenient location, ample parking, and security patrols.\n\nOther reviews mention the traffic can be heavy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-f1b5-766f-bd0c-f282661e8ae1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f1b5-766f-bd0c-f282661e8ae1",
        "storage_key": "property/6767906449165617/019d7912-f1b5-766f-bd0c-f282661e8ae1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.westgatemarketplace.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8926669391805320158&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "westgate-marketplace",
      "poi_latitude": "35.4623795",
      "poi_longitude": "-97.6269281",
      "poi_miles_from_property": "7.5 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-232-3242",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-caba-76ff-aaec-ec5b3d9ca509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-caba-76ff-aaec-ec5b3d9ca509",
        "storage_key": "property/6767906449165617/019cfb44-caba-76ff-aaec-ec5b3d9ca509.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg-djSskPsocR3ovoLYTm4Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4310b179-3b76-4a57-872c-4ada725de9c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Penn Park Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1401 W I-240 Service Road, Oklahoma City, OK 73139, USA",
      "poi_short_description": "Strip mall featuring a variety of stores, including Michael's and Half Price Books, plus eateries.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-f55c-74c6-b227-22da8e604186.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-f55c-74c6-b227-22da8e604186",
        "storage_key": "property/6767906449165617/019d7912-f55c-74c6-b227-22da8e604186.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://google.com/url?q=https://business.google.com/website_shared/launch_bw.html?f=https://amzn.to/3FDjrMR",
      "poi_directions_map_url": "https://maps.google.com/?cid=14330734621759210267&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "penn-park-shopping-center",
      "poi_latitude": "35.3924561",
      "poi_longitude": "-97.5412085",
      "poi_miles_from_property": "14.7 mi",
      "poi_walking_minutes": "5 hours 21 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-caba-76ff-aaec-ec5b3d9ca509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-caba-76ff-aaec-ec5b3d9ca509",
        "storage_key": "property/6767906449165617/019cfb44-caba-76ff-aaec-ec5b3d9ca509.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0eMzd5QTsocRG4NZBDb_4MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a791c8f6-1e3f-462c-ace6-0302123ec663",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Sprawling shopping center containing retailers, restaurant options & a 24-screen movie theater.",
      "poi_long_description": "People say this shopping center offers a variety of stores, an arcade, and a movie theater. They also highlight the fun atmosphere, the clean environment, and the friendly people.\n\nOther reviews mention some stores can be closed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-fc40-76ca-bda7-de194a46fde6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fc40-76ca-bda7-de194a46fde6",
        "storage_key": "property/6767906449165617/019d7912-fc40-76ca-bda7-de194a46fde6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "18.6 mi",
      "poi_walking_minutes": "6 hours 49 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-caba-76ff-aaec-ec5b3d9ca509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-caba-76ff-aaec-ec5b3d9ca509",
        "storage_key": "property/6767906449165617/019cfb44-caba-76ff-aaec-ec5b3d9ca509.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_643ff815-50e3-40b5-92af-1ded7b918a0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Garden Center at The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "6800 W Reno Ave, Oklahoma City, OK 73127, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7912-fe98-720a-a7c2-8b0667a9bda1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-fe98-720a-a7c2-8b0667a9bda1",
        "storage_key": "property/6767906449165617/019d7912-fe98-720a-a7c2-8b0667a9bda1.webp",
        "width": 1280,
        "height": 745
      },
      "poi_business_url": "https://www.homedepot.com/l/W-Oklahoma-City/OK/Oklahoma-City/73127/3908/garden-center?emt=GCGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11822546147992540290&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "garden-center-at-the-home-depot",
      "poi_latitude": "35.4633453",
      "poi_longitude": "-97.632673",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-789-3895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-caba-76ff-aaec-ec5b3d9ca509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-caba-76ff-aaec-ec5b3d9ca509",
        "storage_key": "property/6767906449165617/019cfb44-caba-76ff-aaec-ec5b3d9ca509.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjdnqJDgPsocRghTCQxUfEqQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden_center"
    },
    {
      "id": "custom_e95a18ca-cc51-4f64-b37e-67f5333da25c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Old World imports antiques and more 3128 North May ave",
      "poi_type": "Shopping & Retail",
      "poi_address": "3128 N May Ave, Oklahoma City, OK 73112, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-0034-754e-abab-4b7647028c6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0034-754e-abab-4b7647028c6a",
        "storage_key": "property/6767906449165617/019d7913-0034-754e-abab-4b7647028c6a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10894888381019493872&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-world-imports-antiques-and-more-3128-north-may-ave",
      "poi_latitude": "35.501717",
      "poi_longitude": "-97.5650539",
      "poi_miles_from_property": "11.4 mi",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-949-0024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-caba-76ff-aaec-ec5b3d9ca509.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-caba-76ff-aaec-ec5b3d9ca509",
        "storage_key": "property/6767906449165617/019cfb44-caba-76ff-aaec-ec5b3d9ca509.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJGXsJhsYRsocR8JUySkJrMpc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_a82d255d-b150-4524-874d-0613c9d007cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Oklahoma City Zoo",
      "poi_type": "Entertainment",
      "poi_address": "2000 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Zoo with an array of animals, plus walking trails, shows & attractions such as train tours.",
      "poi_long_description": "Visitors say this zoo offers a wide variety of animals, including elephants, giraffes, stingrays, and a petting zoo, with fun activities like giraffe feeding and a splash pad. They also highlight the friendly and helpful staff, the clean and well-maintained facilities, and the affordable prices, especially with discounts for families and military members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-0386-744b-ab02-1cb5763b824f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0386-744b-ab02-1cb5763b824f",
        "storage_key": "property/6767906449165617/019d7913-0386-744b-ab02-1cb5763b824f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://okczoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5013321368135377402&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-city-zoo",
      "poi_latitude": "35.5238895",
      "poi_longitude": "-97.4724932",
      "poi_miles_from_property": "18.0 mi",
      "poi_walking_minutes": "6 hours 35 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 405-424-3344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca7a-735b-9ba8-edd45c018e96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca7a-735b-9ba8-edd45c018e96",
        "storage_key": "property/6767906449165617/019cfb44-ca7a-735b-9ba8-edd45c018e96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_EZ4YPguocR-qGV_DjlkkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_9fc7201b-e02e-4b66-bd23-65da6521861e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Science Museum Oklahoma",
      "poi_type": "Entertainment",
      "poi_address": "2020 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_long_description": "People say this science museum offers a wide variety of fun, interactive exhibits and activities, including a planetarium and a slanted room. They highlight the educational value, the engaging live shows, and the spacious layout that prevents overcrowding. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-04b3-751c-ab39-b520eaacfac8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-04b3-751c-ab39-b520eaacfac8",
        "storage_key": "property/6767906449165617/019d7913-04b3-751c-ab39-b520eaacfac8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sciencemuseumok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678503685854338412&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "science-museum-oklahoma",
      "poi_latitude": "35.5237553",
      "poi_longitude": "-97.4754913",
      "poi_miles_from_property": "17.6 mi",
      "poi_walking_minutes": "6 hours 28 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 405-602-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-5144-7738-95b2-79aabe460d31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-5144-7738-95b2-79aabe460d31",
        "storage_key": "property/6767906449165617/019d7913-5144-7738-95b2-79aabe460d31.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTLOFjEYsocRbB1wFzphEqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d1bb422f-b30b-4fc6-8bca-c36079c0e9d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "First Americans Museum",
      "poi_type": "Entertainment",
      "poi_address": "659 First Americans Blvd, Oklahoma City, OK 73129, USA",
      "poi_short_description": "false",
      "poi_long_description": "Visitors say this museum offers a wealth of information about the history and culture of Native Americans, with engaging exhibits including videos, artifacts, and oral histories. They also highlight the stunning architecture of the building and the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-069f-774b-ac4d-ca8a48a0a217.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-069f-774b-ac4d-ca8a48a0a217",
        "storage_key": "property/6767906449165617/019d7913-069f-774b-ac4d-ca8a48a0a217.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.famok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1363703120278945108&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "first-americans-museum",
      "poi_latitude": "35.4580352",
      "poi_longitude": "-97.4820974",
      "poi_miles_from_property": "16.4 mi",
      "poi_walking_minutes": "6 hours 3 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-594-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-5144-7738-95b2-79aabe460d31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-5144-7738-95b2-79aabe460d31",
        "storage_key": "property/6767906449165617/019d7913-5144-7738-95b2-79aabe460d31.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB4b90oEXsocRVH1RP8PY7BI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_aabafd45-f51c-42ae-b4bd-7be5e305e868",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "National Cowboy & Western Heritage Museum",
      "poi_type": "Entertainment",
      "poi_address": "1700 NE 63rd St, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Dioramas, artifacts, art & more documenting & interpreting the history of the American West.",
      "poi_long_description": "People say this heritage museum offers a vast collection of Western art, artifacts, and historical exhibits, including sculptures, paintings, clothing, and personal items from historical figures. They highlight the educational and family-friendly atmosphere, with engaging multi-media displays, outdoor exhibits, and a playground. They also like the friendly and knowledgeable staff, and the informative presentations by docents. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-0c32-746f-9723-214141631147.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-0c32-746f-9723-214141631147",
        "storage_key": "property/6767906449165617/019d7913-0c32-746f-9723-214141631147.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://nationalcowboymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4849781199640138445&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "national-cowboy-western-heritage-museum",
      "poi_latitude": "35.5356997",
      "poi_longitude": "-97.4831286",
      "poi_miles_from_property": "18.0 mi",
      "poi_walking_minutes": "6 hours 37 mins",
      "poi_biking_minutes": "1 hour 55 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 405-478-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-5144-7738-95b2-79aabe460d31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-5144-7738-95b2-79aabe460d31",
        "storage_key": "property/6767906449165617/019d7913-5144-7738-95b2-79aabe460d31.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-cenbQZsocRzRLrSk7iTUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1771bf93-93e9-4f4f-9a64-a9cf9f9b2091",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Myriad Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "301 W Reno Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A 15-acre facility with formal gardens, a tropical conservatory, a dog park & horticultural classes.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, including tropical plants, orchids, and tulips, and features a conservatory, greenhouse, and walking paths. They highlight the beautiful and peaceful atmosphere, perfect for relaxing and taking photos, and the family-friendly amenities, such as a playground, splash pad, and carousel. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-1128-715c-ba97-77cbbb58c50b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-1128-715c-ba97-77cbbb58c50b",
        "storage_key": "property/6767906449165617/019d7913-1128-715c-ba97-77cbbb58c50b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.myriadgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10363530004578021372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "myriad-botanical-gardens",
      "poi_latitude": "35.46533110000001",
      "poi_longitude": "-97.5179073",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "4 hours 53 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-445-7080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca7a-735b-9ba8-edd45c018e96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca7a-735b-9ba8-edd45c018e96",
        "storage_key": "property/6767906449165617/019cfb44-ca7a-735b-9ba8-edd45c018e96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA05XnykXsocR_K_5faGn0o8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_4620f0d6-f240-45a5-b70d-87ea5c66072d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Lost Lakes Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3501 NE 10th St, Oklahoma City, OK 73117, USA",
      "poi_short_description": "Large concert stage for seasonal gigs at a lakeside entertainment, water sports & camping venue.",
      "poi_long_description": "Large concert stage for seasonal gigs at a lakeside entertainment, water sports & camping venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-1179-70ec-94ec-5a33c2605558.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-1179-70ec-94ec-5a33c2605558",
        "storage_key": "property/6767906449165617/019d7913-1179-70ec-94ec-5a33c2605558.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.lostlakesok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15443645988595734308&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lost-lakes-adventure-park",
      "poi_latitude": "35.4806082",
      "poi_longitude": "-97.448123",
      "poi_miles_from_property": "17.1 mi",
      "poi_walking_minutes": "6 hours 20 mins",
      "poi_biking_minutes": "1 hour 37 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-702-4040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca7a-735b-9ba8-edd45c018e96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca7a-735b-9ba8-edd45c018e96",
        "storage_key": "property/6767906449165617/019cfb44-ca7a-735b-9ba8-edd45c018e96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG_fcAtsXsocRJJci4zPaUtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_b6c076b9-9c28-4da9-90ec-28480993bae0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Museum of Osteology",
      "poi_type": "Entertainment",
      "poi_address": "10301 S Sunnylane Rd, Oklahoma City, OK 73160, USA",
      "poi_short_description": "Unique spot for educational exhibits of 300+ skeletons of many species plus hands-on displays.",
      "poi_long_description": "Visitors say this museum offers a unique experience with a vast collection of skeletons, including animals, humans, and forensic exhibits. They also highlight the friendly and knowledgeable staff, educational value, and engaging scavenger hunts for all ages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-11ab-778f-a5e6-7dd5d41fdf2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-11ab-778f-a5e6-7dd5d41fdf2c",
        "storage_key": "property/6767906449165617/019d7913-11ab-778f-a5e6-7dd5d41fdf2c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.skeletonmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9091622308725140297&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "museum-of-osteology",
      "poi_latitude": "35.3648349",
      "poi_longitude": "-97.4418414",
      "poi_miles_from_property": "22.3 mi",
      "poi_walking_minutes": "8 hours 10 mins",
      "poi_biking_minutes": "2 hours 7 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 405-814-0006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-5144-7738-95b2-79aabe460d31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-5144-7738-95b2-79aabe460d31",
        "storage_key": "property/6767906449165617/019d7913-5144-7738-95b2-79aabe460d31.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ57ahxGMVsocRSSuU_1HuK34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a426992f-777b-4fe4-8502-ddf0771ec62a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Cactus Jack's Family Fun Center",
      "poi_type": "Entertainment",
      "poi_address": "1211 N Council Rd, Oklahoma City, OK 73127, USA",
      "poi_short_description": "Pinball machines and classic arcade games are featured at this laid-back spot.",
      "poi_long_description": "People say this video arcade offers a wide variety of games, including many pinball machines, and provides a nostalgic, old-time arcade feel. They highlight the fun and affordable experience, and the spacious, clean environment. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019d7913-4007-7737-b228-041140eda764.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-4007-7737-b228-041140eda764",
        "storage_key": "property/6767906449165617/019d7913-4007-7737-b228-041140eda764.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cjarcade.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5027539140756979412&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cactus-jack-s-family-fun-center",
      "poi_latitude": "35.481307",
      "poi_longitude": "-97.654648",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-789-9846",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-ca7a-735b-9ba8-edd45c018e96.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb44-ca7a-735b-9ba8-edd45c018e96",
        "storage_key": "property/6767906449165617/019cfb44-ca7a-735b-9ba8-edd45c018e96.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt41AG54PsocR1D4xIzZoxUU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "video_arcade"
    },
    {
      "id": "custom_bfc591d1-99ae-4a35-b5ad-60ca0c02641c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Forever 21",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "forever-21",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ca6953a0-9154-4f88-8b42-9f5c4da2bc9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "poi_name": "Wagon Wheel Mercantile",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "wagon-wheel-mercantile",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_262d29ad31762320e8636b0f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7f0f6b052ee3327897f79760",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_b2b3f018db9ab3255211a2d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e262f1b15f2b8ca66ceecac2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a86290de862c783cb968a9cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_64f4f0190aee7427b1ace331",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_05c231f7-cc96-420c-89fd-d54f0358f631",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "rating": "5.0",
      "name": "Yajaira Fernandez",
      "text": "Kayla and the office team have been wonderful. We’ve lived here nearly three years and recently transferred to a larger unit—the process was seamless. I highly recommend these apartments, and as someone in property management myself, that speaks volumes.",
      "date": "2025-10-03",
      "title": ""
    },
    {
      "id": "custom_790c0a92-8da6-41ba-8005-f04993dc861b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "rating": "5.0",
      "name": "janice holden",
      "text": "My husband and I have been living here 1 year July 2024, and have been enjoying it. We love the staff especially Kayla and Jordan, they make you feel like family and willing to help with any problems or concerns you have. Glad we chose this apt community. Would highly recommend to family and friends.",
      "date": "2025-08-29",
      "title": ""
    },
    {
      "id": "custom_c50110f1-dd22-44e8-956e-7656d9baeacd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "rating": "5.0",
      "name": "Jeremiah Garcia",
      "text": "Me and my sister experience such a great time. The lady's up there were phenomenal. They were patient and very helpful. Best experience I ever had at any apartment hunt. I believe we’ll be future residence!",
      "date": "2025-09-25",
      "title": ""
    },
    {
      "id": "custom_f08b836f-ee3b-462d-be96-d5d0d3087689",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "rating": "5.0",
      "name": "Gina Hurd",
      "text": "Almost year 4 with The Park on Westpoint. My husband and I are happy with the complex, especially since the exterior upgrade. There are 2 concerns which I am sure can transpire with any complex.  1.  People not picking up after their dogs. The excrement is numerous especially with individuals who own 2 and 3 large size dogs. 2. Parking is an issue as several in the immediate area own 3 to 4 automobiles.\n\nMaintenance is timely and friendly.",
      "date": "2025-08-19",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_ece1b237-57ec-471f-8af2-72179e524088",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb45-5b3f-7139-876e-c53e1b74d891.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of community pool and surrounding lounge area.",
        "public_id": "019cfb45-5b3f-7139-876e-c53e1b74d891",
        "storage_key": "property/6767906449165617/019cfb45-5b3f-7139-876e-c53e1b74d891.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Park at Westpointe Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f770eefc021d22418c6966d"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-4d61-711f-9ff6-6899b7fd2e31",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "park-at-westpointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617"
    },
    {
      "lead_collector_id": "019cf79e-4dd4-762c-83f1-c4694be136e1",
      "lead_source": "LANDING_PAGE",
      "name": "park-at-westpointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "apartments-pools-yukon-ok",
      "search_query": "apartments with pools in Yukon OK",
      "category": "Amenity",
      "h1_title": "Apartments with Pools in Yukon, OK",
      "h2_subtitle": "Discover luxurious apartments with pools in Yukon, OK. Enjoy two sparkling resort-style pools at Park at Westpointe.",
      "page_copy": "Searching for apartments with pools in Yukon, OK? Look no further than Park at Westpointe, offering not one, but two resort-style swimming pools for you to unwind and relax. Situated in a vibrant area of southwest Oklahoma City, our community extends a welcoming feel with spacious floor plans that cater to comfortable living.\n\nBeyond the pools, Park at Westpointe provides a suite of amenities including a 24-hour fitness center, ensuring residents can maintain an active lifestyle. Enjoy central heat and air conditioning, as well as convenient washer and dryer connections in every apartment. Ready to simplify your life? Take advantage of online rental payments and flexible living options. Your ideal home oasis awaits at Park at Westpointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Yukon OK Apartments with Pools",
      "seo_description": "Find the perfect Yukon OK apartments with pools at Park at Westpointe, offering luxury amenities and convenient living in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-southwest-okc",
      "search_query": "dog friendly apartments Southwest Oklahoma City",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Southwest OKC",
      "h2_subtitle": "Explore dog friendly apartments in Southwest Oklahoma City. Park at Westpointe offers a welcoming environment for you and your furry friend.",
      "page_copy": "If you're on the hunt for dog friendly apartments in Southwest Oklahoma City, Park at Westpointe is the ideal choice. Our community is designed with pet lovers in mind, featuring a convenient on-site dog park where your furry friends can frolic and socialize. Nestled in a prime location, our apartments provide the perfect balance of comfort and convenience.\n\nAt Park at Westpointe, you'll enjoy more than just pet-friendly living. Our expansive, light-filled floor plans and top-notch amenities, including two resort-style swimming pools and a 24-hour fitness center, enhance your living experience. With central heat, air conditioning, and washer/dryer connections, our homes are tailored to meet all your needs. Embrace pet-friendly comfort and a vibrant community atmosphere at Park at Westpointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Southwest OKC",
      "seo_description": "Find dog friendly apartments in Southwest Oklahoma City at Park at Westpointe, featuring a pet-friendly community and fantastic amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "apartments-with-dishwashers-yukon-73099",
      "search_query": "apartments with dishwashers in Yukon 73099",
      "category": "Amenity",
      "h1_title": "Yukon 73099 Apartments with Dishwashers",
      "h2_subtitle": "Find apartments with dishwashers in Yukon, 73099. Park at Westpointe offers modern conveniences for effortless living.",
      "page_copy": "Looking for apartments with dishwashers in Yukon, 73099? Park at Westpointe specializes in providing homes with modern conveniences to make your life easier. Nestled in a sought-after location, our community offers well-appointed apartments designed for comfort and ease.\n\nOur welcoming community not only includes dishwashers but also presents an array of amenities such as two resort-style swimming pools and a 24-hour fitness center. Each apartment is equipped with central heating, air conditioning, and washer/dryer connections to ensure a seamless living experience. Enjoy the spacious floor plans and the option of online rental payments, making Park at Westpointe a perfect home destination.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Yukon 73099 Apartments with Dishwashers",
      "seo_description": "Discover Yukon 73099 apartments with dishwashers at Park at Westpointe, offering modern living with delightful amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-sw-okc",
      "search_query": "fitness center apartments in Southwest Oklahoma City",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Southwest OKC",
      "h2_subtitle": "Discover apartments with a fitness center in Southwest Oklahoma City. Park at Westpointe features a 24-hour gym for residents.",
      "page_copy": "For those searching for fitness center apartments in Southwest Oklahoma City, Park at Westpointe stands out as the ideal choice. Offering a state-of-the-art 24-hour fitness center, our community makes it easy to maintain an active lifestyle right at home. Located in a vibrant neighborhood, our apartments provide an exceptional living experience.\n\nBeyond the fitness center, Park at Westpointe hosts a variety of resort-style amenities like two sparkling swimming pools, enhancing relaxation and leisure opportunities. Our spacious floor plans feature central heat, air conditioning, and convenient washer/dryer connections for comfortable living. Experience a community that prioritizes wellness and ease at Park at Westpointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Southwest OKC Apartments with Fitness Center",
      "seo_description": "Find Southwest OKC fitness center apartments at Park at Westpointe, offering a 24-hour gym and excellent amenities for a premium lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "luxury-apartment-homes-private-balconies-yukon",
      "search_query": "luxury apartment homes with private balconies in Yukon",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Private Balconies in Yukon",
      "h2_subtitle": "Explore luxury apartment homes with private balconies in Yukon. Park at Westpointe offers the pinnacle of stylish living.",
      "page_copy": "For those seeking luxury apartment homes with private balconies in Yukon, Park at Westpointe offers the ultimate living experience. Our upscale community combines style and comfort with features like private balconies that offer serene views and the ideal spot for relaxation. Situated in a prime location, our apartments are designed for those who appreciate the finer things in life.\n\nPark at Westpointe doesn't stop at private balconies; our residents enjoy a host of premium amenities. From two stunning resort-style swimming pools to a comprehensive 24-hour fitness center, there's something for everyone. Our spacious floor plans offer central heat and air conditioning, ensuring your comfort year-round. Experience the height of luxury and convenience in Yukon at Park at Westpointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Yukon Luxury Apartments with Private Balconies",
      "seo_description": "Discover luxury apartment homes with private balconies in Yukon at Park at Westpointe, where style meets exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-yukon-ok",
      "search_query": "1 bedroom apartments yukon ok",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Yukon, OK",
      "h2_subtitle": "Find 1 bedroom apartments in Yukon, OK at Park at Westpointe. Enjoy cozy living with top-notch amenities.",
      "page_copy": "If you're on the hunt for 1 bedroom apartments in Yukon, OK, look no further than Park at Westpointe. Our community offers inviting one-bedroom units perfect for singles or couples seeking a balance of comfort and style. Seamlessly combining modern design with functional living spaces, these apartments are ideal for anyone looking to call Yukon home.\n\nResidents of Park at Westpointe also have access to an array of amenities designed to enhance their lifestyle. Whether you’re unwinding at one of our two resort-style swimming pools or keeping fit at our 24-hour fitness center, there’s something for every taste. With central heat and air, and washer/dryer connections, our apartments provide the ultimate living experience in Yukon, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Yukon, OK",
      "seo_description": "Discover 1 bedroom apartments in Yukon, OK at Park at Westpointe, offering cozy units and exceptional amenities for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-southwest-oklahoma-city",
      "search_query": "2 bedroom apartments southwest oklahoma city",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Southwest OKC",
      "h2_subtitle": "Discover spacious 2 bedroom apartments in Southwest Oklahoma City at Park at Westpointe. Perfect for families and roommates.",
      "page_copy": "Park at Westpointe offers ideal 2 bedroom apartments in Southwest Oklahoma City, perfect for families or roommates seeking comfortable living. Our spacious floor plans are designed to maximize comfort and style, ensuring a delightful living experience. Nestled in a vibrant neighborhood, these apartments provide easy access to all the conveniences of Southwest Oklahoma City.\n\nOur residents enjoy stellar amenities that enrich everyday life, including two resort-style swimming pools and a 24-hour fitness center, perfect for maintaining an active lifestyle. Each apartment is equipped with central heat, air conditioning, and washer/dryer connections for ultimate convenience. Experience the perfect blend of comfort and community at Park at Westpointe's 2 bedroom apartments in Southwest OKC.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Southwest Oklahoma City",
      "seo_description": "Explore spacious 2 bedroom apartments in Southwest OKC at Park at Westpointe. Enjoy modern living with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "apartments-near-southwestern-christian-university-yukon",
      "search_query": "apartments near southwestern christian university yukon",
      "category": "School",
      "h1_title": "Apartments Near Southwestern Christian University",
      "h2_subtitle": "Find the perfect place near Southwestern Christian University in Yukon. Park at Westpointe offers convenient and stylish living.",
      "page_copy": "For students and staff searching for apartments near Southwestern Christian University in Yukon, Park at Westpointe provides an ideal solution. Located just a short drive from the university, our community offers a balance of convenience and comfort, making it the perfect place to unwind after a busy day on campus.\n\nOur apartments boast attractive amenities, including two resort-style swimming pools and a 24-hour fitness center, ensuring a lifestyle both active and relaxed. Each unit is designed with modern comforts such as central heat and air conditioning, plus convenient washer and dryer connections. Experience the ease of living close to Southwestern Christian University while enjoying the modern amenities at Park at Westpointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Southwestern Christian University Yukon",
      "seo_description": "Discover stylish living near Southwestern Christian University at Park at Westpointe in Yukon, offering convenience and superb amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "apartments-near-bethany-childrens-health-center-yukon",
      "search_query": "apartments near Bethany Children's Health Center Yukon",
      "category": "Hospital",
      "h1_title": "Apartments Near Bethany Children's Health Center",
      "h2_subtitle": "Find ideal apartments near Bethany Children's Health Center in Yukon. Park at Westpointe offers a peaceful and convenient living experience.",
      "page_copy": "Park at Westpointe offers the perfect living environment for those seeking apartments near Bethany Children's Health Center in Yukon. Our prime location not only provides easy access to the health center but also ensures that residents enjoy a serene and comfortable community atmosphere.\n\nResidents can take advantage of our superb amenities, which include two resort-style swimming pools, a state-of-the-art 24-hour fitness center, and cozy courtyards perfect for relaxation. Apartments are equipped with essential features like central heat, air conditioning, and washer/dryer connections, ensuring comfort and convenience. Choose Park at Westpointe for effortless living near Bethany Children's Health Center in Yukon.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bethany Children's Health Center Yukon",
      "seo_description": "Discover convenient living near Bethany Children's Health Center at Park at Westpointe in Yukon, with modern amenities and easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "apartments-near-integris-health-emergency-department-yukon",
      "search_query": "apartments close to INTEGRIS Health Emergency Department Canadian Valley Hospital Oklahoma",
      "category": "Hospital",
      "h1_title": "Apartments Near INTEGRIS Health Hospital",
      "h2_subtitle": "Discover convenient apartments close to INTEGRIS Health Emergency Department at Canadian Valley Hospital in Oklahoma. Enjoy modern living at Park at Westpointe.",
      "page_copy": "Park at Westpointe is the ideal choice for those seeking apartments near the INTEGRIS Health Emergency Department at Canadian Valley Hospital in Oklahoma. Situated just a short drive away, our community offers not only convenience but also a tranquil living environment perfect for healthcare professionals and patients’ families alike.\n\nOur residents benefit from a wealth of amenities designed to enhance their lifestyle, including two luxurious resort-style swimming pools and a fully equipped 24-hour fitness center. Each apartment boasts features such as central heat and air conditioning, plus washer and dryer connections, all crafted for your ultimate comfort. Choose Park at Westpointe for a peaceful retreat close to INTEGRIS Health Emergency Department in Yukon.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near INTEGRIS Health Hospital Oklahoma",
      "seo_description": "Explore modern apartments near INTEGRIS Health Emergency Department at Canadian Valley Hospital in Yukon. Enjoy convenient access and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "apartments-near-chisholm-trail-park-yukon-ok",
      "search_query": "apartments near Chisholm Trail Park Yukon OK",
      "category": "Park",
      "h1_title": "Apartments Near Chisholm Trail Park Yukon",
      "h2_subtitle": "Live close to the scenic Chisholm Trail Park in Yukon, OK. Park at Westpointe offers comfortable and modern apartments.",
      "page_copy": "Discover the perfect living environment at Park at Westpointe, offering apartments near Chisholm Trail Park in Yukon, OK. This scenic park provides a wonderful backdrop for outdoor enthusiasts and families alike, featuring trails, playgrounds, and community events year-round.\n\nPark at Westpointe enhances your lifestyle with standout amenities such as two resort-style swimming pools and a 24-hour fitness center. Apartments include modern conveniences like central heating, air conditioning, and washer/dryer connections, designed for comfortable living. Whether enjoying a peaceful evening stroll at Chisholm Trail Park or unwinding at home, Park at Westpointe delivers a lifestyle of convenience and relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Chisholm Trail Park Yukon",
      "seo_description": "Find modern apartments near Chisholm Trail Park in Yukon, OK at Park at Westpointe. Enjoy great amenities and convenient park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "rentals-near-wild-horse-park-southwest-oklahoma-city",
      "search_query": "rentals close to Wild Horse Park in Southwest Oklahoma City",
      "category": "Park",
      "h1_title": "Rentals Near Wild Horse Park OKC",
      "h2_subtitle": "Discover rentals close to Wild Horse Park in Southwest Oklahoma City. Park at Westpointe offers convenience and comfort just minutes away.",
      "page_copy": "Located just a short drive from Wild Horse Park, Park at Westpointe in Southwest Oklahoma City offers the ideal rental homes for those looking to enjoy both city convenience and natural beauty. Wild Horse Park is a local favorite, boasting sports fields, walking trails, and spaces for community events, providing plenty of activities for all ages.\n\nAt Park at Westpointe, residents are treated to a host of amenities including two sparkling resort-style swimming pools and a state-of-the-art 24-hour fitness center. Our apartments feature essential comforts like central heat, air conditioning, and washer/dryer connections. Enjoy easy access to Wild Horse Park while living in a community designed for ultimate relaxation and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Wild Horse Park OKC",
      "seo_description": "Explore comfortable rentals near Wild Horse Park in Southwest Oklahoma City. Enjoy great amenities and easy park access at Park at Westpointe.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "living-near-overholser-park-yukon",
      "search_query": "living close to Overholser Park Yukon",
      "category": "Park",
      "h1_title": "Living Close to Overholser Park Yukon",
      "h2_subtitle": "Experience the ease of living close to Overholser Park in Yukon. Park at Westpointe offers modern amenities and tranquil surroundings.",
      "page_copy": "For those dreaming of living close to Overholser Park in Yukon, Park at Westpointe offers a perfect home base. Overholser Park is renowned for its scenic beauty and abundant recreational opportunities, from peaceful walks along the lake to picnics and more.\n\nPark at Westpointe complements this idyllic park-side lifestyle with a range of amenities designed to enhance comfort. With swimming pools, a 24-hour fitness center, and thoughtfully designed apartment features like central heat, air conditioning, and washer/dryer connections, you can enjoy a balanced life of action and relaxation just minutes away from Overholser Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Overholser Park Yukon",
      "seo_description": "Discover a wonderful living experience close to Overholser Park in Yukon at Park at Westpointe. Enjoy modern amenities and serene surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "homes-near-route-66-park-yukon-73099",
      "search_query": "homes near Route 66 Park OK 73099",
      "category": "Park",
      "h1_title": "Homes Near Route 66 Park in Yukon",
      "h2_subtitle": "Find homes near Route 66 Park in Yukon, OK for a vibrant lifestyle. Park at Westpointe provides a perfect blend of comfort and convenience.",
      "page_copy": "For those seeking homes near Route 66 Park in Yukon, OK, Park at Westpointe offers a unique blend of modern living and recreational proximity. Route 66 Park, famous for its iconic trails and lush landscapes, presents endless opportunities for fun and relaxation, right in your backyard.\n\nPark at Westpointe features a host of exceptional amenities, including two resort-style swimming pools and a 24-hour fitness center. Our homes are thoughtfully equipped with features like central heating and air conditioning, plus in-unit washer and dryer connections, catering to a comfortable and convenient lifestyle. Enjoy both scenic tranquility and vibrant city life at Park at Westpointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Homes Near Route 66 Park Yukon OK",
      "seo_description": "Explore homes near Route 66 Park in Yukon, OK at Park at Westpointe. Enjoy modern amenities and near park activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165617",
      "source": "generator",
      "page_item_url": "apartments-near-yukon-christmas-in-the-park",
      "search_query": "apartments by Yukon Christmas in the Park",
      "category": "Park",
      "h1_title": "Apartments by Yukon Christmas in the Park",
      "h2_subtitle": "Enjoy the festive charm of Apartments by Yukon Christmas in the Park. Park at Westpointe offers ideal accommodations in a holiday hotspot.",
      "page_copy": "Nestled close to the festive annual event of Yukon Christmas in the Park, Park at Westpointe provides the perfect apartments for those who love holiday magic. Our community enjoys a fantastic location that allows easy access to this celebrated event, where dazzling light displays and holiday spirit abound.\n\nLiving at Park at Westpointe means more than just proximity to holiday cheer. Our apartments offer everyday comfort with amenities including resort-style swimming pools, a 24-hour fitness center, and in-unit conveniences like washer/dryer connections and central heating and air conditioning. Celebrate the season and enjoy a cozy lifestyle all year round at Park at Westpointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
      "featured_image_media": {
        "alt_text": "Stylish living room with a sectional sofa, armchair, and coffee table.",
        "public_id": "019cfb44-aee1-7413-b1c9-d65734d92950",
        "storage_key": "property/6767906449165617/019cfb44-aee1-7413-b1c9-d65734d92950.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Yukon Christmas in the Park",
      "seo_description": "Find festive charm at Park at Westpointe with its location near Yukon Christmas in the Park, offering modern living and holiday excitement.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5194"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-0M2KE2ZFXV"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151656"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/park-westpointe/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WW5ZZ2S8"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165617/019d1bd9-1fad-729b-97cd-ccdf6149cb51.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "8ea68db5-5056-448d-a2b7-0b000b5f08f3"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-611-5737"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64e8c79df594a8d2d2d9a414"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkY5V2tXL1NWUXFWY2gvQWFIRE5lNUE9PSIsInZhbHVlIjoiWk1TeHNTMmF6VDgzNVpuTDNqM2dTUT09IiwibWFjIjoiNTEzMmI2ZmIxNDY0NTlkNGI3Yjg1OWY3YWY2ODBmZTQ0ZmRjNTU2MTczMTdmYjI1YzhkZmU0MjY1ZWU0MmM1YyJ9"
    }
  ],
  "custom_qb_id": "5194",
  "custom_ga4_id": "G-0M2KE2ZFXV",
  "custom_repli_id": "10041151656",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/park-westpointe/register/",
  "custom_google_gtm_id": "GTM-WW5ZZ2S8",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165617/019d1bd9-1fad-729b-97cd-ccdf6149cb51.pdf",
  "custom_rentgrata_property_id": "8ea68db5-5056-448d-a2b7-0b000b5f08f3",
  "custom_ppc_tracking_phone_number": "800-611-5737",
  "custom_residentboost_apartment_id": "64e8c79df594a8d2d2d9a414",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkY5V2tXL1NWUXFWY2gvQWFIRE5lNUE9PSIsInZhbHVlIjoiWk1TeHNTMmF6VDgzNVpuTDNqM2dTUT09IiwibWFjIjoiNTEzMmI2ZmIxNDY0NTlkNGI3Yjg1OWY3YWY2ODBmZTQ0ZmRjNTU2MTczMTdmYjI1YzhkZmU0MjY1ZWU0MmM1YyJ9"
};

export const generatedAt = '2026-08-27T21:37:28.348Z';
